/** Türkçe kaynak metin → İngilizce. Eksik anahtar Türkçe döner (test: i18n.test.ts tüm t() anahtarlarını denetler). */
export const en: Record<string, string> = {
  // ── Genel / kabuk ──────────────────────────────────────────────────────
  "TaşDuvar": "TaşDuvar",
  "Taş istinat duvarı analizi · TBDY 2018 §16.12 · Hesap motoru v": "Stone retaining wall analysis · TBDY 2018 §16.12 · Engine v",
  "Hesap motoru v": "Engine v",
  "Hesaplar tarayıcınızda yapılır": "Calculations run in your browser",
  "; projeleriniz sunucuda şifreli bağlantıyla saklanır.": "; your projects are stored on the server over an encrypted connection.",
  "＋ Yeni Proje": "＋ New project",
  "Künyeyi girin, varsayılan bir duvarla başlayın.": "Enter the project info and start with a default wall.",
  " Bulutta saklanır.": " Stored in the cloud.",
  "Proje Aç": "Open project",
  ".tasduvar.json dosyasından": "from a .tasduvar.json file",
  "Projelerim": "My projects",
  "bulut · tüm cihazlarınızda": "cloud · on all your devices",
  "Bulut projelerim": "My cloud projects",
  "Bulut projesi": "Cloud project",
  "Buluta taşı": "Move to cloud",
  "Bu cihazdaki taslaklar": "Drafts on this device",
  "Son projeler": "Recent projects",
  "· yalnız bu tarayıcıda": "· only in this browser",
  "Henüz kayıtlı proje yok.": "No saved projects yet.",
  "Yükleniyor…": "Loading…",
  "Yenile": "Refresh",
  "Planlar": "Plans",
  "Gizlilik": "Privacy",
  "Kullanım şartları": "Terms of use",
  "Hesap": "Account",
  "Çıkış": "Sign out",
  "Giriş yap": "Sign in",
  "Hesap oluştur": "Create account",
  "Aç": "Open",
  "Sil": "Delete",
  "Kapat": "Close",
  "Vazgeç": "Cancel",
  "İptal": "Cancel",
  "Kaydet": "Save",
  "Kaydet (JSON)": "Save (JSON)",
  "Oluştur": "Create",
  "Yeniden dene": "Retry",
  "Beklenmeyen hata:": "Unexpected error:",
  "Rapor": "Report",
  "· Rapor": "· Report",
  "Uygulama": "App",
  "Ana sayfa": "Home",
  "← Giriş": "← Home",
  "Tümü": "All",
  "ve": "and",
  "veya": "or",
  "Hayır": "No",
  "Değer": "Value",
  "Simge": "Symbol",
  "Birim": "Unit",
  "Tanım": "Description",
  "Durum": "Status",
  "Durum:": "Status:",
  "Tarih": "Date",
  "Yer": "Location",
  "Sayfa": "Page",
  "Sonuç": "Result",
  "Sonuçlar": "Results",
  "Sonuç yok.": "No result.",
  "Yöntem": "Method",
  "Kontrol": "Check",
  "Kontroller": "Checks",
  "Hedef": "Target",
  "Oran": "Ratio",
  "Etki": "Action",
  "Direnç (tasarım)": "Resistance (design)",
  "Genel hüküm": "Overall verdict",
  "Kuvvet": "Force",
  "Kuvvet tablosu": "Force table",
  "Değişiklikler": "Changes",
  "Notlar": "Notes",
  "Açıklama": "Description",
  // ── Proje künyesi ─────────────────────────────────────────────────────
  "Künye": "Project info",
  "Künyeyi düzenle": "Edit project info",
  "Proje künyesi": "Project information",
  "Yeni proje künyesi": "New project information",
  "Proje adı": "Project name",
  "Proje adı zorunlu": "Project name is required",
  "Proje": "Project",
  "İl": "Province",
  "İlçe": "District",
  "İl / İlçe": "Province / District",
  "Ada": "Block",
  "Parsel": "Parcel",
  "Ada / Parsel": "Block / Parcel",
  "İşveren": "Client",
  "Proje müellifi": "Design engineer",
  "Oda sicil no": "Chamber registration no.",
  "Oda sicil:": "Chamber reg.:",
  "Revizyon": "Revision",
  "Tarih / Revizyon": "Date / Revision",
  "Kontrol eden kurum": "Reviewing authority",
  "İmza / kaşe": "Signature / stamp",
  "Duvar sayısı": "Number of walls",
  // ── Üst çubuk / senkron / paylaşım ────────────────────────────────────
  "Geçmiş": "History",
  "Paylaş": "Share",
  "Sürüm geçmişi": "Version history",
  "son 20 kayıt": "last 20 saves",
  "Henüz önceki sürüm yok.": "No earlier versions yet.",
  "Geri yükle": "Restore",
  "Paylaşım bağlantısı": "Share link",
  "Paylaşım adresi": "Share URL",
  "Bağlantıyı alan herkes projeyi oturum açmadan salt okunur görür. İstediğiniz zaman iptal edebilirsiniz.": "Anyone with the link can view the project read-only without signing in. You can revoke it at any time.",
  "Rapor indirmeye izin ver (PDF/Word/DXF/JSON)": "Allow report download (PDF/Word/DXF/JSON)",
  "Geçerlilik": "Valid for",
  "7 gün": "7 days",
  "30 gün": "30 days",
  "90 gün": "90 days",
  "Süresiz": "No expiry",
  "süresiz": "no expiry",
  "Bağlantı oluştur": "Create link",
  "Aktif bağlantılar": "Active links",
  "Kopyala": "Copy",
  "Kopyalandı": "Copied",
  "indirme açık": "download allowed",
  "yalnız görüntüleme": "view only",
  "Proje çakışması": "Project conflict",
  "Bu proje başka bir cihazda değişmiş": "This project was changed on another device",
  "Sunucudaki sürüm": "The server version",
  "tarihinde kaydedilmiş; sizin değişiklikleriniz onun üzerine yazılmadı.": "was saved at that time; your changes were not written over it.",
  "Sunucuyu al": "Take server version",
  "— buradaki değişiklikler atılır": "— changes made here are discarded",
  "Üzerine yaz": "Overwrite",
  "— sunucudaki sürüm geçmişe gider": "— the server version goes to history",
  "Kopya olarak sakla": "Save as copy",
  "— ikisi de kalır": "— both are kept",
  // ── Duvar listesi / duvar ekranı ──────────────────────────────────────
  "Duvarlar": "Walls",
  "Duvar": "Wall",
  "duvar ·": "walls ·",
  "Duvar ekle": "Add wall",
  "Duvar seçin.": "Select a wall.",
  "Yeniden adlandırmak için çift tıklayın": "Double-click to rename",
  "Girdiler": "Inputs",
  "Kesit çizimi": "Section drawing",
  "Kesit": "Section",
  "Duvar kesiti": "Wall section",
  "Çizim yük durumu": "Drawing load case",
  "Statik": "Static",
  "Depremli": "Seismic",
  "Deprem ↑ (1−kv)": "Seismic ↑ (1−kv)",
  "Deprem ↓ (1+kv)": "Seismic ↓ (1+kv)",
  "▽ YASS": "▽ GWL",
  // ── Girdi sekmeleri ───────────────────────────────────────────────────
  "Geometri": "Geometry",
  "Dolgu": "Backfill",
  "Temel": "Foundation",
  "Su": "Water",
  "TaşDuvar ana sayfa": "TaşDuvar home",
  "Örnek duvar": "Sample wall",
  "Örnek kesit paftası": "Sample section sheet",
  "Yönetmelik": "Design code",
  "Devrilme GK": "Overturning FS",
  "Üç yönetmelik, tek girdi": "Three design codes, one input",
  "TBDY 2018 γR'li doğrulama, Eurocode 7 kısmi katsayı kombinasyonları (DA1/DA2/DA3) ve ABD ASD hedefleri aynı duvar üzerinde; profil değişince hedefler ve deprem katsayısı türetimi birlikte değişir.": "TBDY 2018 γR verification, Eurocode 7 partial-factor combinations (DA1/DA2/DA3) and US ASD targets on the same wall; switching the profile changes targets and seismic coefficient derivation together.",
  "Depremli hesap açık hesapla": "Seismic design with the working shown",
  "Mononobe-Okabe ile statik + dinamik itki, duvar ve kama ataleti, kh/kv doğrudan girişi; her adımın formülü ve yerine konmuş sayıları raporda.": "Static + dynamic thrust with Mononobe-Okabe, wall and wedge inertia, direct kh/kv input; every step's formula and substituted numbers in the report.",
  "Kesit çiziminden rapora": "From section drawing to report",
  "Ölçüleri çizim üzerinde düzenleyin, çokgen kesit çizin, 3B görünümde kontrol edin; PDF, Word ve DXF çıktısı Türkçe ya da İngilizce.": "Edit dimensions on the drawing, draw polygon sections, check them in 3D; PDF, Word and DXF output in Turkish or English.",
  "Taş istinat duvarı hesabı, kesitten rapora.": "Stone retaining wall design, from section to report.",
  "Ağırlık ve konsol duvarlar için TBDY 2018, Eurocode 7 ve ABD pratiğine göre devrilme, kayma, taşıma gücü ve iç kesit kontrolleri. Girdiyi değiştirdiğiniz anda kesit ve hükümler yenilenir.": "Overturning, sliding, bearing and internal section checks for gravity and cantilever walls to TBDY 2018, Eurocode 7 and US practice. The section and verdicts update the moment you change an input.",
  "Yeni proje": "New project",
  "Dosyadan aç": "Open from file",
  "; giriş yaparsanız projeleriniz tüm cihazlarınızda açılır.": "; sign in and your projects open on all your devices.",
  "; projeler bu cihazda saklanır.": "; projects are stored on this device.",
  "bulut, tüm cihazlarınızda": "cloud, on all your devices",
  "yalnız bu tarayıcıda": "this browser only",
  "Yeni proje ile başlayın; taslak otomatik kaydedilir.": "Start with New project; drafts save automatically.",
  "Güncelleme": "Updated",
  "Ekle": "Add", "Hesap hatası": "Calculation error", "Tüm kontroller sağlanıyor": "All checks satisfied", "Sağlanmayan kontrol var": "Some checks not satisfied",
  "Ölçüler": "Dimensions", "Kuvvetler": "Forces", "Basınç diyagramı": "Pressure diagram", "Taban gerilmesi": "Base pressure", "Kesit kotları": "Section levels",
  "Çizim katmanları": "Drawing layers", "Girdi bölümleri": "Input sections",
  "3B": "3D", "Görünüm": "View",
  "3B görünüm için geçerli bir kesit gerekir.": "A valid section is required for the 3D view.",
  "Tarayıcınız WebGL desteklemiyor; 3B görünüm kullanılamıyor.": "Your browser does not support WebGL; the 3D view is unavailable.",
  "Duvar 3B görünümü": "Wall 3D view",
  "3B görünüm yükleniyor…": "Loading 3D view…",
  "Sürükleyerek döndürün, tekerlekle yakınlaştırın. Duvar boyu": "Drag to rotate, scroll to zoom. Wall length",
  "Yükler": "Loads",
  "Deprem": "Seismic",
  "Malzeme": "Material",
  "Genel": "General",
  "Ön yüz eğimi": "Front batter",
  "0 = düşey, 0,2 = 1/5": "0 = vertical, 0.2 = 1/5",
  "Kademeler (üstten alta)": "Steps (top to bottom)",
  "＋ Kademe ekle": "＋ Add step",
  "Kademe ekle": "Add step",
  "Üst kalınlık": "Top thickness",
  "Alt kalınlık": "Bottom thickness",
  "Gömme derinliği": "Embedment depth",
  "Temel bloğu": "Footing block",
  "Gövde altında burun/topuk çıkıntılı taş/beton temel": "Stone/concrete footing with toe/heel extensions under the stem",
  "Temel bloğu yükseklik / burun / topuk": "Footing height / toe / heel",
  "Taban eğimi (topuk alçak)": "Base slope (heel lower)",
  "0 = yatay taban; 0,1 = %10; 0,2 = 1/5 (5:1 ön yüze dik, KGM Şekil 4.15). Burun sabit, topuk B·tanα alçak; kayma taban düzlemi boyunca kontrol edilir.": "0 = horizontal base; 0.1 = 10%; 0.2 = 1/5 (perpendicular to a 5:1 front face, KGM Fig. 4.15). Toe fixed, heel B·tanα lower; sliding is checked along the base plane.",
  "Temel yüksekliği": "Footing height",
  "0 = temel bloğu yok": "0 = no footing block",
  "Burun çıkıntısı": "Toe extension",
  "Topuk çıkıntısı": "Heel extension",
  "Parametrikten çokgene dönüştür →": "Convert parametric to polygon →",
  "Serbest çokgen: burun (0; 0), taban y = 0 üzerinde yatay, saat yönünün tersi.": "Free polygon: toe at (0; 0), base horizontal on y = 0, counter-clockwise.",
  "Çizimde: ölçüye tıklayıp yeni değer yazın (dik kenarlar birlikte kayar), köşeyi sürükleyin, kenara çift tıklayıp köşe ekleyin, köşeye sağ tıklayıp silin; zemin çizgisi Df'yi, dolgu yüzeyi β'yı sürüklemeyle değiştirir. Sıfırdan çizmek için CIZ komutu.": "In the drawing: click a dimension and type a new value (perpendicular edges move together), drag a vertex, double-click an edge to add a vertex, right-click a vertex to delete it; dragging the ground line sets Df and the backfill surface sets β. Use the CIZ command to draw from scratch.",
  "Temel üstünü çizimden bul": "Detect foundation top from drawing",
  "Derz kotları (otomatik, yatay kademe kenarları):": "Joint levels (automatic, horizontal ledges):",
  "Kesit çiz": "Draw section",
  "Çizim ayarları": "Drawing settings",
  "Çizim ayarları (DXF paftası)": "Drawing settings (DXF sheet)",
  "DXF paftası ayarları — yalnız çizimi etkiler, hesabı değiştirmez. Boş bırakılan çap/aralık alanları Metraj sekmesindeki değerlerle çizilir.": "DXF sheet settings — they affect the drawing only, not the analysis. Diameter/spacing fields left untouched are drawn with the values from the Quantities tab.",
  "Model birimi": "Model unit",
  "Türk pratiğinde cm": "cm in Turkish practice",
  "Yazı ve ok boyutunu belirler (2,5 mm × ölçek)": "Sets text and arrow size (2.5 mm × scale)",
  "Taş dokusu": "Stone hatch",
  "Malzemeden (otomatik)": "From material (automatic)",
  "Moloz taş": "Rubble stone",
  "Kaba yonu / kesme taş": "Roughly dressed / ashlar stone",
  "Kot referansı": "Elevation datum",
  "±0,00 kotu": "±0.00 level",
  "Duvar önü doğal zemin (Df)": "Natural ground in front of the wall (Df)",
  "Temel taban kotu": "Foundation base level",
  "Duvar tepe kotu": "Wall top level",
  "Referansın mutlak kotu": "Absolute elevation of the datum",
  "0 = göreli kotlar (±0,00); ör. 125,40 girilirse kotlar mutlak yazılır": "0 = relative levels (±0.00); enter e.g. 125.40 to print absolute levels",
  "duvar önü doğal zemin kotu": "natural ground level in front of the wall",
  "duvar temel taban kotu": "foundation base level of the wall",
  "duvar tepe kotu": "top level of the wall",
  "Barbakan": "Weep holes",
  "Barbakan çizimi": "Draw weep holes",
  "Metrajdan (drenaja bağlı)": "From quantities (follows drainage)",
  "Çiz": "Draw",
  "Çizme": "Do not draw",
  "Metrajdan": "From quantities",
  "Düşey aralık": "Vertical spacing",
  "Yatay aralık": "Horizontal spacing",
  "Ön görünüşteki sıra aralığı": "Row spacing in the elevation view",
  "İlk sıra yüksekliği": "First row height",
  "Ön zemin kotundan": "From the front ground level",
  "Eğim açısı": "Slope angle",
  "Dışa doğru": "Outwards",
  "Barbakan ölçülerini metrajdan al": "Take weep hole sizes from quantities",
  "Drenaj ve filtre": "Drainage and filter",
  "Drenaj borusu çizimi": "Draw drainage pipe",
  "Boru çapı": "Pipe diameter",
  "0 = çizilmez": "0 = not drawn",
  "Harpuşta ve derzler": "Coping and joints",
  "Harpuşta": "Coping",
  "Duvar tepesinde yerinde dökme beton başlık": "Cast-in-place concrete cap on top of the wall",
  "Harpuşta yüksekliği": "Coping height",
  "Harpuşta taşması": "Coping overhang",
  "Ano / dilatasyon derzi aralığı": "Bay / expansion joint spacing",
  "Ön görünüşte derz çizgisi ve notu": "Joint line and note in the elevation view",
  "DXF'ten al": "From DXF",
  "DXF'ten kesit al": "Import section from DXF",
  "Kapalı bölge bulunamadı: kesit çizgileri uç uca değmiyor olabilir (uçları birleştirip yeniden kaydedin) ya da dosyada yalnız ölçü/metin var.": "No closed region found: the section lines may not meet end to end (join the endpoints and save again), or the file only contains dimensions/text.",
  "Dosya okunamadı": "File could not be read",
  "İçe aktar": "Import",
  "DXF dosyası seç": "Choose DXF file",
  "ASCII DXF (R12–2018); DWG desteklenmez — AutoCAD'de 'Farklı kaydet → DXF'.": "ASCII DXF (R12–2018); DWG is not supported — in AutoCAD use 'Save as → DXF'.",
  "Çizim birimi": "Drawing unit",
  "otomatik": "auto",
  "Sarı bölge içe aktarılır; bölgeye tıklayarak seçimi değiştirin (bitişik bölgeler birleşir: gövde + temel). Katmanlar:": "The yellow region is imported; click a region to change the selection (adjacent regions merge: body + foundation). Layers:",
  "varlık": "entities",
  "kapalı bölge": "closed regions",
  "Kesit motor için geçerli değil:": "Section is not valid for the engine:",
  "Seçim:": "Selection:",
  "köşe": "vertices",
  "temel üstü": "foundation top",
  "burun (0; 0)'a taşınır": "moved to toe (0; 0)",
  "DXF önizleme": "DXF preview",
  "Bölge": "Region",
  "Önizleme kısaltıldı (çok fazla çizgi)": "Preview truncated (too many lines)",
  "Kesit çiz (CIZ)": "Draw section (CIZ)",
  "Nokta: x y · @dx dy · @L<açı · tıkla — K kapat · G geri · IPTAL": "Point: x y · @dx dy · @L<angle · click — K close · G undo · IPTAL cancel",
  "Köşe noktaları": "Vertices",
  "＋ Nokta ekle": "＋ Add point",
  "Nokta ekle": "Add point",
  "Gövde tabanı kotu": "Stem base level",
  "Ek iç kesit kontrol kotları (m)": "Additional joint check levels (m)",
  "＋ Ek kot ekle": "＋ Add level",
  "Ek kot ekle": "Add level",
  "Dolgu tabakaları (üstten alta)": "Backfill layers (top to bottom)",
  "＋ Tabaka ekle": "＋ Add layer",
  "Tabaka ekle": "Add layer",
  "Tabaka": "Layer",
  "Birim hacim ağırlığı": "Unit weight",
  "Doygun birim ağırlık": "Saturated unit weight",
  "YASS altında gerekli": "Required below the groundwater level",
  "İçsel sürtünme açısı": "Internal friction angle",
  "Kohezyon": "Cohesion",
  "Dolgu şev açısı": "Backfill slope angle",
  "β < φ olmalı": "β must be < φ",
  "Duvar-zemin sürtünme açısı modu": "Wall–soil friction angle mode",
  "Duvar-zemin sürtünme açısı": "Wall–soil friction angle",
  "Elle gir": "Enter manually",
  "Elle gir (≤ 2φ/3)": "Enter manually (≤ 2φ/3)",
  "δ değeri": "δ value",
  "δb değeri": "δb value",
  "Geçirimlilik": "Permeability",
  "Geçirimli (k ≥ 5·10⁻⁴ m/s)": "Permeable (k ≥ 5·10⁻⁴ m/s)",
  "Geçirimsiz": "Impermeable",
  "Taban sürtünme açısı": "Base friction angle",
  "TBDY kontrolünde tanδ ≤ 0,6": "tanδ ≤ 0.6 in the TBDY check",
  "Adezyon": "Adhesion",
  "Taşıma gücü kaynağı": "Bearing capacity source",
  "Zemin etüdünden girilir": "Entered from the site investigation",
  "zemin etüdünden alındı": "taken from the site investigation",
  "Denk. 16.8a ile hesapla": "Compute with Eq. 16.8a",
  "TBDY Denk. 16.8a ile hesaplandı": "computed with TBDY Eq. 16.8a",
  "Karakteristik taşıma gücü": "Characteristic bearing capacity",
  "Zemin emniyet gerilmesi": "Allowable bearing pressure",
  "qk / σem oranı": "qk / σem ratio",
  "Biri eksikse diğerinden türetilir": "If one is missing it is derived from the other",
  "0 = orandan türet": "0 = derive from ratio",
  "Pasif direnç": "Passive resistance",
  "Pasif direnç (ön dolgu)": "Passive resistance (front fill)",
  "TBDY'de %30'u, klasikte tamamı": "30 % in TBDY, full value in classic checks",
  "Pasif ihmal derinliği": "Neglected passive depth",
  "İhmal edilen üst derinlik": "Neglected top depth",
  "Drenajlı (N·tanδ)": "Drained (N·tanδ)",
  "Drenajsız (Ac·cu)": "Undrained (Ac·cu)",
  "Drenajsız kayma dayanımı": "Undrained shear strength",
  "Kayma direnci koşulu": "Sliding resistance condition",
  "Duvar arkası yeraltı suyu": "Groundwater behind the wall",
  "Duvar arkası su seviyesi (taban üstünden)": "Water level behind the wall (above base)",
  "Arka su seviyesi (taban üstünden)": "Back water level (above base)",
  "Drenaj varsa kapalı bırakın (TBDY 16.12.3.1)": "Leave off if drainage is provided (TBDY 16.12.3.1)",
  "Duvar önünde su": "Water in front of the wall",
  "Duvar önü su seviyesi": "Front water level",
  "Ön su seviyesi (taban üstünden)": "Front water level (above base)",
  "Suyun birim hacim ağırlığı": "Unit weight of water",
  "Düzgün yayılı sürşarj": "Uniform surcharge",
  "Şerit / çizgisel yükler": "Strip / line loads",
  "＋ Şerit/çizgisel yük ekle": "＋ Add strip/line load",
  "Şerit/çizgisel yük ekle": "Add strip/line load",
  "Şerit (kN/m²)": "Strip (kN/m²)",
  "Çizgisel (kN/m)": "Line (kN/m)",
  "Depremde öz ağırlık çarpanı": "Self-weight factor in seismic case",
  "Deprem hesabı": "Seismic analysis",
  "Giriş yöntemi": "Input method",
  "AFAD haritası (SS, S1, zemin sınıfı)": "AFAD map (SS, S1, site class)",
  "Doğrudan SDS": "Direct SDS",
  "Doğrudan kh, kv (yönetmelik dışı / kıyas)": "Direct kh, kv (outside code / benchmarking)",
  "Deprem yer hareketi düzeyi": "Earthquake ground motion level",
  "DD-1 (2475 yıl)": "DD-1 (2475 yr)",
  "DD-2 (475 yıl) — standart": "DD-2 (475 yr) — standard",
  "DD-3 (72 yıl)": "DD-3 (72 yr)",
  "DD-4 (43 yıl)": "DD-4 (43 yr)",
  "Rapor bilgisi; SDS düzeye göre haritadan alınır": "Report info; SDS is read from the map for this level",
  "Kısa periyot harita katsayısı": "Short-period map coefficient",
  "1,0 s harita katsayısı": "1.0 s map coefficient",
  "Yerel zemin sınıfı": "Site class",
  "ZF: sahaya özel analiz gerekir": "ZF: site-specific analysis required",
  "Yatay deprem katsayısı": "Horizontal seismic coefficient",
  "Düşey deprem katsayısı": "Vertical seismic coefficient",
  "Her iki işaretle (1∓kv) denenir": "Both signs (1∓kv) are tried",
  "Duvar tipi (Tablo 16.7)": "Wall type (Table 16.7)",
  "r = 2,0 — 120·SDS mm yerdeğiştirmeye izin": "r = 2.0 — 120·SDS mm displacement allowed",
  "r = 1,5 — 80·SDS mm": "r = 1.5 — 80·SDS mm",
  "r = 1,0 — yerdeğiştirme yok / ankrajlı": "r = 1.0 — no displacement / anchored",
  "Dinamik artım etkime noktası": "Point of application of dynamic increment",
  "H/2 (TBDY 16.12.2.8)": "H/2 (TBDY 16.12.2.8)",
  "Doygun zemin, boşluk suyu basıncı artışı riski": "Saturated soil, risk of pore-pressure build-up",
  "r ≤ 1 zorlanır (16.12.2.2)": "forces r ≤ 1 (16.12.2.2)",
  "Duvar ataleti (kh·W)": "Wall inertia (kh·W)",
  "Topuk/kama üstü dolgu ve sürşarj ataleti": "Inertia of backfill and surcharge over heel/wedge",
  "TBDY 16.12 tanımlamaz; istCAD/iCad almaz, EN 1998-5 alır (tutucu)": "Not defined in TBDY 16.12; istCAD/iCad omit it, EN 1998-5 includes it (conservative)",
  "Klasik GK da geçme şartı olsun (devrilme/kayma hedefleri, statik e ≤ B/6)": "Classical FS must also pass (overturning/sliding targets, static e ≤ B/6)",
  "Kapalı: hüküm TBDY dayanım katsayılarıyla; klasik GK bilgi amaçlı raporlanır, e ≤ B/3": "Off: verdict by TBDY resistance factors; classical FS reported for information, e ≤ B/3",
  "en çok B/3": "at most B/3",
  "Bilgi amaçlı (hüküm TBDY dayanım katsayılarıyla)": "For information (verdict by TBDY resistance factors)",
  "Devrilme ve kayma GK bilgi amaçlıdır; hüküm bölüm 9'daki TBDY dayanım katsayılarıyla verilir. Taban dış merkezliliği en çok B/3 alınır; taşıma gücünde q ≤ σem sürer.": "Overturning and sliding FS are for information only; the verdict is given by the TBDY resistance factors in section 9. Base eccentricity is limited to B/3; the q ≤ σallow bearing check still applies.",
  "Dolgu ataleti (topuk/kama üstü dolgu ve sürşarj)": "Backfill inertia (backfill and surcharge over heel/wedge)",
  "Dahil (kh·W_dolgu)": "Included (kh·W_fill)",
  "İhmal": "Neglected",
  "Klasik GK (devrilme / kayma)": "Classical FS (overturning / sliding)",
  "Hüküm (geçme şartı)": "Governing (must pass)",
  "Bilgi amaçlı; hüküm TBDY dayanım katsayılarıyla, e ≤ B/3": "For information; verdict by TBDY resistance factors, e ≤ B/3",
  "İMO/AFAD örneği ve EN 1998-5 ile uyumlu": "Consistent with the İMO/AFAD example and EN 1998-5",
  "Hesaplanan deprem parametreleri": "Derived seismic parameters",
  "k_h = 0,4·S_DS/r": "k_h = 0.4·S_DS/r",
  "k_h (doğrudan)": "k_h (direct)",
  "k_v (doğrudan)": "k_v (direct)",
  "θ (1−kv / 1+kv)": "θ (1−kv / 1+kv)",
  "İzin verilen yerdeğiştirme": "Allowed displacement",
  "Taş birim hacim ağırlığı": "Stone unit weight",
  "Moloz taş 24, beton taş 22 (TS 498)": "Rubble stone 24, concrete block 22 (TS 498)",
  "Taş emniyet gerilmesi": "Allowable stone stress",
  "Harçlı taş emniyet basınç gerilmesi": "Allowable compressive stress of mortared masonry",
  "Emniyet basınç gerilmesi": "Allowable compressive stress",
  "Derz sürtünme katsayısı": "Joint friction coefficient",
  "Derz adezyonu": "Joint adhesion",
  "Malzeme açıklaması (raporda)": "Material description (in report)",
  "Klasik güvenlik katsayısı hedefleri": "Classic factor-of-safety targets",
  "Klasik hedef varsayılanları": "Classic target defaults",
  "Devrilme GK hedefi (statik / depremli)": "Overturning FS target (static / seismic)",
  "Kayma GK hedefi (statik / depremli)": "Sliding FS target (static / seismic)",
  "Taşıma gücü çarpanı (statik / depremli)": "Bearing factor (static / seismic)",
  "Dış merkezlilik sınırı B/n (statik / depremli)": "Eccentricity limit B/n (static / seismic)",
  "TBDY devrilme katsayısı": "TBDY overturning factor",
  "TBDY devrilme dayanım katsayısı": "TBDY overturning resistance factor",
  "Kuru (harçsız) taş duvar": "Dry (mortarless) stone wall",
  "Harçlı moloz taş duvar": "Mortared rubble stone wall",
  "Çekiçle kabaca düzeltilmiş (kaba yonu) taş duvar": "Hammer-dressed (roughly squared) stone wall",
  "Yönü taşı (ince yonu) duvar": "Squared (fine-dressed) stone wall",
  "Kesme taş duvar": "Ashlar (cut stone) wall",
  "Özel değerler (elle gir)": "Custom values (enter manually)",
  "TS 2510 2.6.1 yapım yöntemi; kuru duvar yalnız ağırlık istinat/çevre duvarında": "TS 2510 2.6.1 construction method; dry walls only for gravity retaining / boundary walls",
  "Taş cinsi": "Stone type",
  "grup": "group",
  "γ: TS 498 doğal taşlar; grup: TS 2510 Çizelge 1": "γ: TS 498 natural stones; group: TS 2510 Table 1",
  "Harç grubu": "Mortar group",
  "TS 2510 Çizelge 2; σem Çizelge 12 (moloz/yonu) ve 13 (kesme), λ ≤ 10": "TS 2510 Table 2; σem Tables 12 (rubble/dressed) and 13 (ashlar), λ ≤ 10",
  "Ön ayardan (TS 498); değiştirince Özel'e geçer": "From preset (TS 498); editing switches to Custom",
  "Ön ayardan (TS 2510)": "From preset (TS 2510)",
  "Malzeme kaynağı": "Material source",
  "Kireçtaşı (kalker), traverten": "Limestone, travertine",
  "Kireç bağlayıcılı kumtaşı, konglomera": "Lime-bonded sandstone, conglomerate",
  "Yoğun kireçtaşı, dolomit": "Dense limestone, dolomite",
  "Bazalt": "Basalt",
  "Silis bağlayıcılı kumtaşı, grovak": "Silica-bonded sandstone, greywacke",
  "Granit, siyenit, porfir": "Granite, syenite, porphyry",
  "Diyabaz": "Diabase",
  "Diyorit, melafir, gabro": "Diorite, melaphyre, gabbro",
  "A — 1:3 çimento harcı": "A — 1:3 cement mortar",
  "B — 1:4 çimento harcı (çimento takviyeli)": "B — 1:4 cement mortar (cement-reinforced)",
  "C–D — kireç-çimento (bastard) harcı": "C–D — lime-cement (bastard) mortar",
  "E — kireç harcı": "E — lime mortar",
  "TBDY devrilme katsayısı (statik)": "TBDY overturning factor (static)",
  "TBDY devrilme katsayısı (depremli)": "TBDY overturning factor (seismic)",
  "TBDY devrilme dayanım katsayısı (statik)": "TBDY overturning resistance factor (static)",
  "TBDY devrilme dayanım katsayısı (depremli)": "TBDY overturning resistance factor (seismic)",
  "TBDY devrilme dayanım katsayısı (statik / depremli)": "TBDY overturning resistance factor (static / seismic)",
  "≥ 1,3 (16.12.1.1); pratikte 1,5–2,5; γRv 1,4 · γRh 1,1 · γRp 1,4 sabit": "≥ 1.3 (16.12.1.1); 1.5–2.5 in practice; γRv 1.4 · γRh 1.1 · γRp 1.4 fixed",
  "≥ 1,3 (16.12.1.1)": "≥ 1.3 (16.12.1.1)",
  "≥ 1,3 (16.12.1.1); γRv 1,4 · γRh 1,1 · γRp 1,4 sabit": "≥ 1.3 (16.12.1.1); γRv 1.4 · γRh 1.1 · γRp 1.4 fixed",
  "Aktif itkinin düşey bileşeni": "Vertical component of active thrust",
  "Aktif itkinin düşey bileşeni (Pav) dirençte sayılsın": "Count the vertical component of active thrust (Pav) as resistance",
  "İç kesit kontrolleri": "Joint (internal section) checks",
  "İç kesitler": "Internal sections",
  "Kontrol edilecek iç kesit yok (tek kademe, ek kot tanımlanmadı).": "No internal section to check (single step, no extra levels defined).",
  "Varsayılanlar": "Defaults",
  "Varsayılanlara dön": "Reset to defaults",
  "Motor varsayılanlarına dön": "Reset to engine defaults",
  // ── Sonuç paneli ──────────────────────────────────────────────────────
  "TBDY 2018": "TBDY 2018",
  "Klasik": "Classic",
  "Klasik GK": "Classic FS",
  "Kayma GK": "Sliding FS",
  "Devrilme": "Overturning",
  "Kayma": "Sliding",
  "Taşıma gücü": "Bearing capacity",
  "Dış merkezlilik": "Eccentricity",
  "Dış merkezlilik (B/n)": "Eccentricity (B/n)",
  "Derz kayması": "Joint sliding",
  "Derz dış merkezliliği": "Joint eccentricity",
  "Derz dış merkezliliği (b/n)": "Joint eccentricity (b/n)",
  "Devrilme (en büyük oran)": "Overturning (max ratio)",
  "GK = Mr/Mo": "FS = Mr/Mo",
  "GK = ΣFr/ΣFh": "FS = ΣFr/ΣFh",
  "qmax ≤ f·σem (f)": "qmax ≤ f·σem (f)",
  "sınır (1,0)": "limit (1.0)",
  "SAĞLIYOR": "SATISFIED",
  "SAĞLAMIYOR": "NOT SATISFIED",
  "✓ SAĞLIYOR": "✓ SATISFIED",
  "✗ SAĞLAMIYOR": "✗ NOT SATISFIED",
  "TÜM KONTROLLER SAĞLANIYOR": "ALL CHECKS SATISFIED",
  "SAĞLANMAYAN KONTROL VAR": "SOME CHECKS NOT SATISFIED",
  "TÜM DUVARLAR SAĞLIYOR": "ALL WALLS SATISFIED",
  "Hesap yapılamadı": "Analysis failed",
  "Hesap yapılamadı:": "Analysis failed:",
  "Uyarılar ve kabuller": "Warnings and assumptions",
  "TBDY'de kural yok": "No rule in TBDY",
  "TBDY'de sınır yok; e =": "No limit in TBDY; e =",
  "Dış merkezlilik: e = |B/2 − x̄| =": "Eccentricity: e = |B/2 − x̄| =",
  "kN/m · N = ΣV − U =": "kN/m · N = ΣV − U =",
  "kN/m · Direnç ΣHr =": "kN/m · Resistance ΣHr =",
  "U (kaldırma) =": "U (uplift) =",
  "q_burun =": "q_toe =",
  "q_burun": "q_toe",
  "deprem": "seismic",
  "q_topuk": "q_heel",
  "· q_topuk": "· q_heel",
  " · çekmesiz dağılım": " · no-tension distribution",
  "Kp =": "Kp =",
  "Sanal arka düzlem (ψ =": "Virtual back plane (ψ =",
  "Sanal arka düzlem üstünden": "From the top of the virtual back plane",
  "kN/m": "kN/m",
  "kN/m²": "kN/m²",
  "kN/m² (statik)": "kN/m² (static)",
  "H (kN/m)": "H (kN/m)",
  "V (kN/m)": "V (kN/m)",
  "N (kN/m)": "N (kN/m)",
  "Mo (kNm/m)": "Mo (kNm/m)",
  "Mr (kNm/m)": "Mr (kNm/m)",
  "Mo": "Mo",
  "Mr": "Mr",
  "Kas": "Kas",
  "Kad": "Kad",
  "Kat": "Kat",
  "Df (m)": "Df (m)",
  "e_lim (m)": "e_lim (m)",
  "σmax (kN/m²)": "σmax (kN/m²)",
  "Pasif": "Passive",
  "Önleyici": "Resisting",
  "Duvar ataleti": "Wall inertia",
  // ── Rapor ─────────────────────────────────────────────────────────────
  "Rapor Oluştur": "Create report",
  "Rapor ayarları": "Report settings",
  "Hazır ayar": "Preset",
  "Özel (elle seçim)": "Custom (manual selection)",
  "Bölümler": "Sections",
  "← Duvar ekranı": "← Wall screen",
  "PDF (korumalı)": "PDF (protected)",
  "Word": "Word",
  "Proje JSON": "Project JSON",
  "Bu bağlantıda indirme kapalı": "Download is disabled for this link",
  "Dışa aktarma için": "To export,",
  "plan seçin": "choose a plan",
  "TAŞ (KARGİR) AĞIRLIK İSTİNAT DUVARI": "STONE (MASONRY) GRAVITY RETAINING WALL",
  "Statik ve Depremli Stabilite Analizi Raporu": "Static and Seismic Stability Analysis Report",
  "Geometri ve deprem parametreleri": "Geometry and seismic parameters",
  "Statik durum — kuvvetler, basınç diyagramı ve taban gerilmesi": "Static case — forces, pressure diagram and base pressure",
  "TÜM DUVARLAR İÇİN STABİLİTE KOŞULLARI SAĞLANMAKTADIR": "STABILITY REQUIREMENTS ARE SATISFIED FOR ALL WALLS",
  "STABİLİTE KOŞULLARI SAĞLANMAYAN DUVAR VARDIR — KESİT VEYA ZEMİN PARAMETRELERİ GÖZDEN GEÇİRİLMELİDİR": "SOME WALLS DO NOT SATISFY THE STABILITY REQUIREMENTS — REVIEW THE SECTION OR SOIL PARAMETERS",
  "Hesap esasları: Türkiye Bina Deprem Yönetmeliği 2018 (TBDY 2018) §16.12 — İstinat Yapıları; Mononobe-Okabe statik-eşdeğer yöntemi; klasik güvenlik katsayıları (TS 7994).": "Basis of design: Turkish Building Earthquake Code 2018 (TBDY 2018) §16.12 — Retaining Structures; Mononobe-Okabe pseudo-static method; classic factors of safety (TS 7994).",
  "Proje mühendisi kabulü": "Design engineer's acceptance",
  "· dosya özeti": "· file digest",
  "1. Proje ve Duvar Bilgileri": "1. Project and Wall Information",
  "2. Girdiler": "2. Inputs",
  "2.1 Geometri": "2.1 Geometry",
  "2.2 Dolgu": "2.2 Backfill",
  "2.3 Temel zemini": "2.3 Foundation soil",
  "2.4 Su": "2.4 Water",
  "2.5 Yükler": "2.5 Loads",
  "2.6 Deprem": "2.6 Seismic",
  "2.7 Malzeme": "2.7 Material",
  "2.8 Kontrol hedefleri": "2.8 Check targets",
  "3. Kesit Çizimi": "3. Section Drawing",
  "4. Kuvvet Şeması ve Basınç Diyagramı": "4. Force Diagram and Pressure Diagram",
  "5. Deprem Parametreleri": "5. Seismic Parameters",
  "5. Deprem Parametreleri (doğrudan katsayı)": "5. Seismic Parameters (direct coefficients)",
  "5. Deprem Parametreleri (TBDY 2018 §2.3, §16.12.2)": "5. Seismic Parameters (TBDY 2018 §2.3, §16.12.2)",
  "6. Toprak Basıncı Katsayıları": "6. Earth Pressure Coefficients",
  "7. Yük Tablosu": "7. Load Table",
  "8. Hesap Adımları": "8. Calculation Steps",
  "9. TBDY 2018 Stabilite Kontrolleri (§16.12.1, Denk. 16.6–16.21)": "9. TBDY 2018 Stability Checks (§16.12.1, Eqs. 16.6–16.21)",
  "10. Klasik Güvenlik Katsayıları": "10. Classic Factors of Safety",
  "11. Dış Merkezlilik, Taban Gerilmeleri ve Taşıma Gücü": "11. Eccentricity, Base Pressures and Bearing Capacity",
  "12. İç Kesit (Derz) Kontrolleri": "12. Internal Section (Joint) Checks",
  "13. Uyarılar ve Kabuller": "13. Warnings and Assumptions",
  "14. Sonuç ve Değerlendirme": "14. Conclusion and Evaluation",
  "15. Kaynaklar": "15. References",
  "Deprem hesabı yapılmadı.": "No seismic analysis was performed.",
  "Kısa periyot yerel zemin etki katsayısı (Tablo 2.1)": "Short-period site coefficient (Table 2.1)",
  "Kısa periyot tasarım spektral ivme katsayısı": "Short-period design spectral acceleration coefficient",
  "Kısa periyot harita spektral ivme katsayısı": "Short-period map spectral acceleration coefficient",
  "1,0 s periyot harita spektral ivme katsayısı": "1.0 s map spectral acceleration coefficient",
  "1,0 s tasarım spektral ivme katsayısı": "1.0 s design spectral acceleration coefficient",
  "Tasarım spektral ivme katsayısı (doğrudan)": "Design spectral acceleration coefficient (direct)",
  "Duvar tipi katsayısı (Tablo 16.7)": "Wall type factor (Table 16.7)",
  "Yatay statik-eşdeğer deprem katsayısı (Denk. 16.22)": "Horizontal pseudo-static seismic coefficient (Eq. 16.22)",
  "Düşey statik-eşdeğer deprem katsayısı": "Vertical pseudo-static seismic coefficient",
  "Yatay statik-eşdeğer deprem katsayısı (kullanıcı girdisi)": "Horizontal pseudo-static seismic coefficient (user input)",
  "Düşey statik-eşdeğer deprem katsayısı (kullanıcı girdisi)": "Vertical pseudo-static seismic coefficient (user input)",
  "Yatay deprem katsayısı (doğrudan)": "Horizontal seismic coefficient (direct)",
  "Düşey deprem katsayısı (doğrudan)": "Vertical seismic coefficient (direct)",
  "Deprem açısı (1 − kv)": "Seismic angle (1 − kv)",
  "Deprem açısı (1 + kv)": "Seismic angle (1 + kv)",
  "İzin verilen yerdeğiştirme (Tablo 16.7)": "Allowed displacement (Table 16.7)",
  "Katsayılar TBDY 2018 Denk. 16.22 ile türetilmedi; yönetmelik uygunluğu ve izin verilen yerdeğiştirme değerlendirmesi kullanıcıya aittir.": "The coefficients were not derived with TBDY 2018 Eq. 16.22; code compliance and the allowed-displacement assessment are the user's responsibility.",
  "Kat = sin²(ψ+φ−θ) / [cosθ·sin²ψ·sin(ψ−θ−δ)·(1+√(sin(φ+δ)·sin(φ−β−θ)/(sin(ψ−θ−δ)·sin(ψ+β))))²] (φ−β ≥ θ); aksi hâlde Kat = sin²(ψ+φ−θ)/[cosθ·sin²ψ·sin(ψ−θ−δ)] (Denk. 16.24b).": "Kat = sin²(ψ+φ−θ) / [cosθ·sin²ψ·sin(ψ−θ−δ)·(1+√(sin(φ+δ)·sin(φ−β−θ)/(sin(ψ−θ−δ)·sin(ψ+β))))²] (φ−β ≥ θ); otherwise Kat = sin²(ψ+φ−θ)/[cosθ·sin²ψ·sin(ψ−θ−δ)] (Eq. 16.24b).",
  "°) üzerinde Coulomb / Mononobe-Okabe (TBDY Denk. 16.24a-b). Dinamik artım Kad = Kat − Kas.": "°) Coulomb / Mononobe-Okabe (TBDY Eq. 16.24a-b). Dynamic increment Kad = Kat − Kas.",
  "Deprem hesabı statik-eşdeğer Mononobe-Okabe yöntemiyle (TBDY 2018 §16.12.2); dinamik artımın etkime noktası girdi tablosundaki gibidir.": "Seismic analysis uses the pseudo-static Mononobe-Okabe method (TBDY 2018 §16.12.2); the point of application of the dynamic increment is as given in the input table.",
  "Kollar burun (0; 0) noktasına göre. V aşağı (+), H devirici yönde (+). Mr = V·x (V > 0), Mo = H·y + |V|·x (V < 0).": "Lever arms about the toe (0; 0). V downward (+), H in the overturning direction (+). Mr = V·x (V > 0), Mo = H·y + |V|·x (V < 0).",
  "Etki ≤ Direnç / γR. Devrilme γRdev, kayma γRh = 1,1 (pasif direncin %30'u γRp = 1,4 ile), taşıma gücü γRv = 1,4.": "Action ≤ Resistance / γR. Overturning γRdev, sliding γRh = 1.1 (30 % of passive resistance with γRp = 1.4), bearing γRv = 1.4.",
  "Gerilmeler kN/m². * Bileşke çekirdek dışında; çekmesiz üçgen dağılım (temas uzunluğu 3·(B/2 − e)). q_k kaynağı:": "Stresses in kN/m². * Resultant outside the kern; no-tension triangular distribution (contact length 3·(B/2 − e)). q_k source:",
  "q_k = c·N_c·d_c·i_c + q̄·N_q·d_q·i_q + ½·γ·B′·N_γ·d_γ·i_γ (Denk. 16.8a); ayrıntı için hesap adımları bölümüne bakınız.": "q_k = c·N_c·d_c·i_c + q̄·N_q·d_q·i_q + ½·γ·B′·N_γ·d_γ·i_γ (Eq. 16.8a); see the calculation steps section for details.",
  "TBDY 16.12.3.2 (b)/(c)": "TBDY 16.12.3.2 (b)/(c)",
  "Denk.": "Eq.",
  "Türkiye Bina Deprem Yönetmeliği (TBDY 2018), Bölüm 16 — Temel Zemini ve Temeller için Özel Kurallar, §16.12 İstinat Yapıları. Resmî Gazete 18.03.2018/30364.": "Turkish Building Earthquake Code (TBDY 2018), Chapter 16 — Special Rules for Foundation Soils and Foundations, §16.12 Retaining Structures. Official Gazette 18.03.2018/30364.",
  "TS 7994 — Zemin Dayanma Yapıları; Sınıflandırma, Özellikleri ve Projelendirme Esasları.": "TS 7994 — Earth Retaining Structures; Classification, Properties and Design Principles.",
  "TS 498 — Yapı Elemanlarının Boyutlandırılmasında Alınacak Yüklerin Hesap Değerleri.": "TS 498 — Design Loads for Buildings.",
  "EN 1998-5:2004 Eurocode 8 — Bölüm 5: Temeller, istinat yapıları ve geoteknik konular.": "EN 1998-5:2004 Eurocode 8 — Part 5: Foundations, retaining structures and geotechnical aspects.",
  "Mononobe, N. & Matsuo, H. (1929); Okabe, S. (1926) — Statik-eşdeğer dinamik toprak basıncı.": "Mononobe, N. & Matsuo, H. (1929); Okabe, S. (1926) — Pseudo-static dynamic earth pressure.",
  "Das, B. M., Principles of Foundation Engineering (Coulomb ve Mononobe-Okabe toprak basıncı, Boussinesq sürşarj çözümleri).": "Das, B. M., Principles of Foundation Engineering (Coulomb and Mononobe-Okabe earth pressure, Boussinesq surcharge solutions).",
  "Fine GEO5 — Gravity Wall Verification Manual (sanal arka düzlem yaklaşımı ile doğrulama).": "Fine GEO5 — Gravity Wall Verification Manual (validation with the virtual back plane approach).",
  // ── Kimlik / hesap / abonelik ─────────────────────────────────────────
  "Giriş": "Sign in",
  "Giriş sayfası": "Sign-in page",
  "giriş yapın": "sign in",
  "E-posta": "E-mail",
  "E-posta:": "E-mail:",
  "Parola": "Password",
  "Parola (en az 8 karakter)": "Password (at least 8 characters)",
  "Parola (Google hesabında boş)": "Password (leave empty for Google accounts)",
  "Parolamı unuttum": "Forgot my password",
  "Parolanızı değiştirmek için": "To change your password, request a",
  "sıfırlama bağlantısı": "reset link",
  "isteyin.": ".",
  "Parolayı değiştir": "Change password",
  "Yeni parola": "New password",
  "Yeni parola (en az 8 karakter)": "New password (at least 8 characters)",
  "Yeni parola (tekrar)": "New password (repeat)",
  "Google ile devam et": "Continue with Google",
  "Kayıt ol": "Sign up",
  "Kayıt": "Sign up",
  "Kayıt olarak": "By signing up you accept the",
  "kullanım şartlarını": "terms of use",
  "gizlilik bildirimini": "privacy notice",
  "kabul edersiniz. 14 gün ücretsiz deneme otomatik başlar.": ". A 14-day free trial starts automatically.",
  "Ad Soyad": "Full name",
  "Ad:": "Name:",
  "Firma": "Company",
  "Firma:": "Company:",
  "Zaten hesabınız var mı?": "Already have an account?",
  "hesap oluşturun": "create an account",
  "— 14 gün ücretsiz deneme otomatik başlar.": "— a 14-day free trial starts automatically.",
  "E-postanızı doğrulayın": "Verify your e-mail",
  "Doğrulama e-postası": "Verification e-mail",
  "adresine bir doğrulama bağlantısı gönderdik. Bağlantıya tıkladığınızda hesabınız açılır ve oturum başlar.": "— we sent a verification link to this address. Clicking it activates your account and signs you in.",
  "E-posta gelmediyse gereksiz klasörüne bakın.": "If the e-mail did not arrive, check your spam folder.",
  "Yeniden gönder": "Send again",
  "Bağlantı gönder": "Send link",
  "Bu adresle kayıtlı bir hesap varsa sıfırlama bağlantısı gönderildi (1 saat geçerli).": "If an account exists for this address, a reset link has been sent (valid for 1 hour).",
  "Bağlantı eksik. E-postadaki bağlantıyı kullanın.": "The link is incomplete. Use the link from the e-mail.",
  "Hesabım": "My account",
  "Profil": "Profile",
  "yönetici": "admin",
  "(yönetici)": "(admin)",
  "Sağlayıcı paneli": "Provider panel",
  "Abonelik": "Subscription",
  "Abonelik durumu": "Subscription status",
  "Hesap ve abonelik": "Account and subscription",
  "Plan yok": "No plan",
  "bitiş": "ends",
  "Plan seç": "Choose a plan",
  "Süreyi uzat": "Extend",
  "Projeleriniz salt okunur: görüntüleyebilir ve JSON indirebilirsiniz; düzenleme, yeni proje ve rapor dışa aktarma için plan seçin.": "Your projects are read-only: you can view them and download JSON; choose a plan to edit, create projects and export reports.",
  "Deneme süresince raporlarda \"": "During the trial, reports carry the \"",
  "\" filigranı basılır.": "\" watermark.",
  "Ödemeler": "Payments",
  "Henüz ödeme yok.": "No payments yet.",
  "Plan": "Plan",
  "Tutar": "Amount",
  "Havale": "Bank transfer",
  "Kart": "Card",
  "Referans": "Reference",
  "Hesabı sil": "Delete account",
  "Hesabımı sil": "Delete my account",
  "Hesabınız, projeleriniz ve paylaşım bağlantılarınız kalıcı olarak silinir (KVKK). Önce projelerinizi JSON olarak indirmenizi öneririz.": "Your account, projects and share links are permanently deleted (KVKK/GDPR). We recommend downloading your projects as JSON first.",
  "Ödemeniz alındı, planınız etkinleştirildi.": "Your payment was received and your plan is active.",
  "Ödeme tamamlanamadı. Tekrar deneyebilir ya da havale ile ödeyebilirsiniz.": "The payment could not be completed. You can try again or pay by bank transfer.",
  "Ödemeniz bankadan onay bekliyor.": "Your payment is awaiting bank confirmation.",
  "Plan seçenekleri": "Plan options",
  "Plan seçmek için": "To choose a plan,",
  "Sınırsız proje, bulut kayıt ve cihazlar arası senkron": "Unlimited projects, cloud storage and sync across devices",
  "Filigransız PDF/Word/DXF rapor": "PDF/Word/DXF reports without watermark",
  "Paylaşım bağlantısı ve sürüm geçmişi": "Share links and version history",
  "2 ay bedava": "2 months free",
  "yıl": "year",
  "· KDV dâhil": "· VAT included",
  "Havale ile öde": "Pay by bank transfer",
  "Kartla öde": "Pay by card",
  "Havale / EFT bilgileri": "Bank transfer details",
  "Havale bilgileri": "Bank transfer details",
  "Alıcı": "Beneficiary",
  "Ödemeniz onaylanınca planınız etkinleşir ve e-posta alırsınız. Durumu": "Your plan is activated once the payment is confirmed and you receive an e-mail. You can follow the status on the",
  "sayfasından izleyebilirsiniz.": "page.",
  "Kart ödemeleri iyzico altyapısıyla alınır; kart bilgileriniz sunucumuza ulaşmaz. Fatura için hesap sayfasından bize yazın.": "Card payments are processed by iyzico; your card details never reach our server. For invoices, contact us from the account page.",
  "Yönetici hesabıyla giriş yapın.": "Sign in with an admin account.",
  "Bu sayfa yalnız yönetici hesabına açıktır.": "This page is only available to admin accounts.",
  "sunucu ·": "server ·",
  // ── Yönetim ───────────────────────────────────────────────────────────
  "Sağlayıcı girişi": "Provider sign-in",
  "Gir": "Enter",
  "Tarayıcıda saklanan ayar ve parola gerçek bir güvenlik sınırı değildir; yanlışlıkla değişikliği önlemek içindir.": "Settings and password stored in the browser are not a real security boundary; they only prevent accidental changes.",
  "Kullanıcılar": "Users",
  "Kullanıcı": "User",
  "kullanıcı": "users",
  "Kullanıcı ara": "Search users",
  "e-posta veya ad": "e-mail or name",
  "Ara": "Search",
  "Plan ver": "Grant plan",
  "Ver": "Grant",
  "Yönetici yap": "Make admin",
  "Yetkiyi al": "Revoke admin",
  "Engelle": "Block",
  "Engeli kaldır": "Unblock",
  "· engelli": "· blocked",
  " · doğrulanmamış": " · unverified",
  "İstatistikler": "Statistics",
  "Ödeme filtresi": "Payment filter",
  "Bekleyen havaleler": "Pending transfers",
  "Kayıt yok.": "No records.",
  "Ödeme geldi": "Payment received",
  "Reddet": "Reject",
  "Özellikler": "Features",
  "Günlük": "Log",
  "Aktar": "Transfer",
  "Korumalı görüntü-PDF": "Protected image PDF",
  "Açıkken PDF düğmesi sayfaları görüntü olarak basar: metin seçilemez/aranamaz, yalnız yazdırma izni; dosya sayfa başına ~0,5–1 MB. OCR ile aşılabilir.": "When enabled, the PDF button renders pages as images: text cannot be selected/searched, print-only permission; file size ~0.5–1 MB per page. Can be bypassed with OCR.",
  "Rapor alt bilgi metni": "Report footer text",
  "Yazılım ibaresi (kapak)": "Software note (cover)",
  "Filigran (boş = yok)": "Watermark (empty = none)",
  "Logo (PNG/JPG, kapakta)": "Logo (PNG/JPG, on cover)",
  "Kaldır": "Remove",
  "Havale bilgileri (Planlar sayfasında gösterilir)": "Bank transfer details (shown on the Plans page)",
  "IBAN": "IBAN",
  "Hesap sahibi": "Account holder",
  "Havale notu": "Transfer note",
  "Yeni oluşturulan duvarlara uygulanır (spec §6.9). Boş bırakılan alan motor varsayılanını kullanır.": "Applied to newly created walls (spec §6.9). Empty fields use the engine default.",
  "Kapalı özellik arayüzde gri görünür ve kullanılamaz; mevcut projelerdeki veri korunur ve motor tam hesaplar.": "A disabled feature appears greyed out and cannot be used; data in existing projects is preserved and the engine still computes fully.",
  "Kullanım günlüğü": "Usage log",
  "Kullanım günlüğü sunucuda tutulur (dışa aktarma ve paylaşım görüntülemeleri).": "The usage log is kept on the server (exports and share views).",
  "CSV indir": "Download CSV",
  "CSV indir (sunucu)": "Download CSV (server)",
  "Temizle": "Clear",
  "kayıt (en fazla 500)": "records (max 500)",
  "Henüz kayıt yok.": "No records yet.",
  "Biçim": "Format",
  "Ayarları dışa aktar (JSON)": "Export settings (JSON)",
  "Ayarları içe aktar": "Import settings",
  "Dışa aktarılan dosya": "The exported file also contains",
  "havale bilgilerini": "the bank transfer details",
  "parola özetini ve kullanım günlüğünü": "the password hash and the usage log",
  "de içerir.": ".",
  // ── Hukuki ────────────────────────────────────────────────────────────
  "Gizlilik bildirimi (KVKK)": "Privacy notice (KVKK/GDPR)",
  "Hangi verileri topluyoruz?": "What data do we collect?",
  "Hesap için e-posta, ad soyad ve isteğe bağlı oda sicil numarası / firma adı. Google ile girişte Google'ın paylaştığı e-posta ve ad. Proje dosyalarınız (duvar geometrisi, zemin ve yük verileri) ve dışa aktarma günlüğü (tarih, proje adı, biçim).": "For the account: e-mail, full name and optionally chamber registration number / company. With Google sign-in: the e-mail and name Google shares. Your project files (wall geometry, soil and load data) and the export log (date, project name, format).",
  "Ne için kullanıyoruz?": "What do we use it for?",
  "Hizmeti sunmak (projelerinizi saklamak ve cihazlar arasında eşitlemek), abonelik ve ödeme işlemlerini yürütmek, güvenlik ve hata giderme. Verileriniz reklam amacıyla kullanılmaz, üçüncü taraflara satılmaz.": "To provide the service (store and sync your projects across devices), to handle subscriptions and payments, security and troubleshooting. Your data is not used for advertising and is not sold to third parties.",
  "Nerede saklanıyor?": "Where is it stored?",
  "Verileriniz Almanya'daki sunucumuzda, şifreli bağlantı (TLS) üzerinden saklanır; günlük yedek alınır. Kart ödemeleri iyzico tarafından işlenir; kart bilgileri sunucumuza ulaşmaz.": "Your data is stored on our server in Germany over an encrypted connection (TLS); daily backups are taken. Card payments are processed by iyzico; card details never reach our server.",
  "Haklarınız": "Your rights",
  "KVKK m.11 uyarınca verilerinize erişme, düzeltme ve silme hakkınız vardır. Projelerinizi her zaman JSON olarak indirebilir; \"Hesabımı sil\" ile hesabınızı ve tüm projelerinizi kalıcı olarak silebilirsiniz. Hesap silindiğinde yedeklerden de en geç 30 gün içinde kaldırılır.": "Under KVKK art. 11 (and GDPR) you have the right to access, correct and delete your data. You can always download your projects as JSON; \"Delete my account\" permanently deletes your account and all projects. Deleted accounts are removed from backups within 30 days.",
  "Çerezler": "Cookies",
  "Yalnız oturum çerezi (`tds`, 30 gün) ve Google girişi sırasında kısa ömürlü güvenlik çerezi kullanılır; takip çerezi yoktur.": "Only a session cookie (`tds`, 30 days) and a short-lived security cookie during Google sign-in are used; there are no tracking cookies.",
  "İletişim": "Contact",
  "Sorularınız için hesap sayfasındaki iletişim adresine yazabilirsiniz.": "For questions, write to the contact address on the account page.",
  "Hizmet": "Service",
  "TaşDuvar, taş istinat duvarlarının TBDY 2018 §16.12 ve klasik yöntemlere göre ön boyutlandırma ve stabilite hesabını yapan bir yazılımdır. Hesaplar tarayıcınızda yapılır; sunucu projelerinizi saklar ve eşitler.": "TaşDuvar is software for the preliminary sizing and stability analysis of stone retaining walls according to TBDY 2018 §16.12 and classic methods. Calculations run in your browser; the server stores and syncs your projects.",
  "Mühendislik sorumluluğu": "Engineering responsibility",
  "Yazılım bir hesap aracıdır; girdilerin doğruluğu, sonuçların yorumu ve projenin onayı imza yetkili mühendisin sorumluluğundadır. Raporlar kontrol edilmeden kullanılmamalıdır. Yazılım \"olduğu gibi\" sunulur; dolaylı zararlardan sorumluluk kabul edilmez.": "The software is a calculation tool; the correctness of inputs, interpretation of results and approval of the design are the responsibility of the licensed engineer. Reports must not be used without review. The software is provided \"as is\"; no liability is accepted for consequential damages.",
  "Kayıtta 14 günlük ücretsiz deneme başlar. Aylık ve yıllık abonelikler peşin ödenir; süre dolunca projeleriniz silinmez, salt okunur olur ve JSON olarak indirilebilir. Havale ile ödeme yönetici onayıyla, kart ödemesi iyzico üzerinden anında etkinleşir. İade: ödemeden sonraki 14 gün içinde, hizmet kullanılmamışsa.": "A 14-day free trial starts at sign-up. Monthly and yearly subscriptions are paid in advance; when they expire your projects are not deleted but become read-only and can be downloaded as JSON. Bank transfers are activated after admin confirmation, card payments instantly via iyzico. Refunds: within 14 days of payment if the service has not been used.",
  "Kabul edilebilir kullanım": "Acceptable use",
  "Hesap kişiseldir, paylaşılamaz. Yazılımın tersine mühendisliği, sistemin kötüye kullanımı ve başkalarının verilerine erişim girişimi yasaktır.": "Accounts are personal and may not be shared. Reverse engineering the software, abusing the system and attempting to access other users' data are prohibited.",
  "Şartlar güncellenebilir; önemli değişiklikler e-posta ile bildirilir.": "The terms may be updated; significant changes are announced by e-mail.",
  "Taslak metin — hukuki gözden geçirme öncesi bilgilendirme amaçlıdır. Son güncelleme: 18.09.2026": "Draft text — for information before legal review. Last updated: 18.09.2026",
  // ── Sayfa başlıkları / çeşitli ────────────────────────────────────────
  "✕ Sil": "✕ Delete",
  // ── Yönetmelik profilleri (Task 4) ───────────────────────────────────
  "Hesap esasları: EN 1997-1 (Eurocode 7) kısmi katsayılı tasarım — EQU ve GEO kombinasyonları; EN 1998-5 statik-eşdeğer deprem etkisi (Mononobe-Okabe); klasik güvenlik katsayıları bilgi amaçlı.": "Basis of design: EN 1997-1 (Eurocode 7) partial-factor design — EQU and GEO combinations; EN 1998-5 pseudo-static seismic action (Mononobe-Okabe); classic factors of safety for information.",
  "Hesap esasları: IBC 2021 §1807.2 ve AASHTO LRFD §11.6 (ASD güvenlik katsayıları: devrilme/kayma 1,5, taşıma gücü 3); Coulomb / Mononobe-Okabe toprak basıncı (kh = 0,5·kmax).": "Basis of design: IBC 2021 §1807.2 and AASHTO LRFD §11.6 (ASD factors of safety: overturning/sliding 1.5, bearing 3); Coulomb / Mononobe-Okabe earth pressure (kh = 0.5·kmax).",
  "9. Yönetmelik Doğrulaması (ABD — IBC 2021 §1807.2 / AASHTO LRFD §11.6)": "9. Code Verification (US — IBC 2021 §1807.2 / AASHTO LRFD §11.6)",
  "ABD profilinde doğrulama yalnız klasik güvenlik katsayılarıyla yapılır (bölüm 10): devrilme ve kayma GK ≥ 1,5 (depremde 1,1), taşıma gücü GK 3, bileşke B/6 (depremde B/3) içinde.": "In the US profile verification uses classic factors of safety only (section 10): overturning and sliding FS ≥ 1.5 (1.1 seismic), bearing FS 3, resultant within B/6 (B/3 seismic).",
  "9. Eurocode 7 Kısmi Katsayılı Doğrulama (EN 1997-1 §2.4.7, Ek A)": "9. Eurocode 7 Partial-Factor Verification (EN 1997-1 §2.4.7, Annex A)",
  "E_d ≤ R_d. Etkiler γG (aleyhte) / γG,fav (lehte) ve γQ; malzeme tanφ/γφ, c/γc; dirençler γRh, γRv, γRe. Devrilme EQU, kayma ve taşıma GEO sınır durumları. Tek kaynak ilkesi: itkinin düşey bileşeni kayma/devrilmede lehte, taşımada aleyhte.": "E_d ≤ R_d. Actions γG (unfavourable) / γG,fav (favourable) and γQ; materials tanφ/γφ, c/γc; resistances γRh, γRv, γRe. Overturning EQU, sliding and bearing GEO limit states. Single-source principle: the vertical component of the thrust is favourable in sliding/overturning and unfavourable in bearing.",
  "Kombinasyon": "Combination",
  "Devrilme E/R": "Overturning E/R",
  "Kayma E/R": "Sliding E/R",
  "Taşıma E/R": "Bearing E/R",
  "Yönetmelik kuralı yok (yalnız GK)": "No code rule (FS only)",
  "e =": "e =",
  "Yönetmelik profili": "Design code profile",
  "Kısmi katsayılar EN 1997-1 Ek A; EQU + GEO kombinasyonları raporda": "Partial factors EN 1997-1 Annex A; EQU + GEO combinations in the report",
  "Yalnız klasik GK; hedefler IBC 2021 §1807.2 / AASHTO (devrilme 1,5, kayma 1,5, e ≤ B/6, depremde B/3)": "Classic FS only; targets IBC 2021 §1807.2 / AASHTO (overturning 1.5, sliding 1.5, e ≤ B/6, B/3 seismic)",
  "Dirençler γR ile (16.12.1) + klasik GK tablosu": "Resistances with γR (16.12.1) + classic FS table",
  "Tasarım yaklaşımı": "Design approach",
  "Depremde sürşarj katsayısı": "Surcharge factor in seismic case",
  "EN 1990 Tablo A1.1: yol/park 0,3, depo 0,8": "EN 1990 Table A1.1: traffic/parking 0.3, storage 0.8",
  "Kama üstü sürşarj ağırlığı devrilme/kaymada lehte sayılsın": "Count surcharge weight on the wedge as favourable in overturning/sliding",
  "Toprak itkisi yöntemi": "Earth pressure method",
  "Sanal arka düzlem (topuktan; kama ağırlığı düşey yük)": "Virtual back plane (through the heel; wedge weight as vertical load)",
  "Gerçek arka yüz / kademe bazlı (her kademe kendi ψ ile)": "Actual back face / step-based (each step with its own ψ)",
  "Das / ders kitabı ağırlık duvarı pratiği: itki kademe arka yüzlerine δ ile eğik; kademe çıkıntısı üstündeki dolgu düşey yük": "Das / textbook gravity-wall practice: thrust on each step's back face inclined at δ; soil above step ledges as vertical load",
  "iCad Rijit ile birebir doğrulanmış varsayılan; konsol ve ampatmanlı duvarlar için": "Default, validated against iCad Rijit; for cantilever and footed walls",
  "Yöntem: kademe bazlı — itki gerçek arka yüze her kademe için kendi ψᵢ ile (Coulomb / M-O) uygulanmış; kademe çıkıntısı üstündeki dolgu düşey yük alınmıştır (Das / ders kitabı ağırlık duvarı pratiği).": "Method: step-based — the thrust is applied to the actual back face with each step's own ψᵢ (Coulomb / M-O); soil above step ledges is taken as vertical load (Das / textbook gravity-wall practice).",
  "Yöntem: sanal düzlem — itki topuktan geçen sanal arka düzlem üzerinde hesaplanmış, düzlem ile duvar arasındaki dolgu ağırlık alınmıştır (iCad Rijit ile aynı yaklaşım).": "Method: virtual plane — the thrust is computed on the virtual back plane through the heel; soil between the plane and the wall is taken as weight (same approach as iCad Rijit).",
  "Kıyas — statik devrilme / kayma GK:": "Comparison — static overturning / sliding FS:",
  "kademe bazlı": "step-based",
  "sanal düzlem": "virtual plane",
  "Yöntem: kademe bazlı — her kademe arka yüzü kendi ψᵢ ile Coulomb / Mononobe-Okabe (TBDY Denk. 16.24a-b):": "Method: step-based — each step's back face with its own ψᵢ, Coulomb / Mononobe-Okabe (TBDY Eq. 16.24a-b):",
  "kademe": "step",
  "Dinamik artım Kad = Kat − Kas.": "Dynamic increment Kad = Kat − Kas.",
  "Kapalı: EC7 / ders notu pratiği (lehte değişken etki alınmaz); taban gerilmesinde her zaman sayılır": "Off: EC7 / textbook practice (favourable variable action ignored); always counted for base pressure",
  "EN 1998-5: ag·S, γI, r": "EN 1998-5: ag·S, γI, r",
  "AASHTO: PGA, FPGA (kh = 0,5·kmax)": "AASHTO: PGA, FPGA (kh = 0.5·kmax)",
  "Referans yer ivmesi": "Reference ground acceleration",
  "agR·γI / g; ulusal harita": "agR·γI / g; national map",
  "Zemin katsayısı": "Soil factor",
  "EN 1998-1 Tablo 3.2/3.3 (A 1,0 · B 1,2 · C 1,15 · D 1,35 · E 1,4)": "EN 1998-1 Table 3.2/3.3 (A 1.0 · B 1.2 · C 1.15 · D 1.35 · E 1.4)",
  "Önem katsayısı": "Importance factor",
  "Düşey/yatay ivme oranı": "Vertical/horizontal acceleration ratio",
  "> 0,6 → kv = 0,5·kh; aksi 0,33·kh (Denk. 7.2)": "> 0.6 → kv = 0.5·kh; otherwise 0.33·kh (Eq. 7.2)",
  "Zirve yer ivmesi": "Peak ground acceleration",
  "USGS/AASHTO 1000 yıl haritası": "USGS/AASHTO 1000-year map",
  "AASHTO Tablo 3.10.3.2-1": "AASHTO Table 3.10.3.2-1",
  "1–2 inç yer değiştirmeye izin (kh = 0,5·kmax)": "Allow 1–2 in displacement (kh = 0.5·kmax)",
  "Duvar tipi (EN 1998-5 Tablo 7.1)": "Wall type (EN 1998-5 Table 7.1)",
  "EN 1997-1:2004 Eurocode 7 — Geoteknik tasarım, Bölüm 1: Genel kurallar; Ek A (kısmi katsayılar), Ek D (taşıma gücü).": "EN 1997-1:2004 Eurocode 7 — Geotechnical design, Part 1: General rules; Annex A (partial factors), Annex D (bearing resistance).",
  "EN 1998-5:2004 Eurocode 8 — Bölüm 5: Temeller, istinat yapıları ve geoteknik konular (§7.3.2, Ek E).": "EN 1998-5:2004 Eurocode 8 — Part 5: Foundations, retaining structures and geotechnical aspects (§7.3.2, Annex E).",
  "EN 1990:2002 — Yapı tasarımının esasları (kombinasyonlar, ψ katsayıları).": "EN 1990:2002 — Basis of structural design (combinations, ψ factors).",
  "IBC 2021 — International Building Code, §1807.2 Retaining Walls (devrilme ve kayma için GK ≥ 1,5).": "IBC 2021 — International Building Code, §1807.2 Retaining Walls (FS ≥ 1.5 for overturning and sliding).",
  "AASHTO LRFD Bridge Design Specifications (9th ed.), §11.6 Abutments and Conventional Retaining Walls; §11.6.5 Seismic Design (kh = 0,5·kmax).": "AASHTO LRFD Bridge Design Specifications (9th ed.), §11.6 Abutments and Conventional Retaining Walls; §11.6.5 Seismic Design (kh = 0.5·kmax).",
  "ASCE/SEI 7-22 — §11 Seismic Design Criteria (PGA, FPGA).": "ASCE/SEI 7-22 — §11 Seismic Design Criteria (PGA, FPGA).",
  "NAVFAC DM-7.02 — Foundations and Earth Structures.": "NAVFAC DM-7.02 — Foundations and Earth Structures.",
  "Das, B. M., Principles of Foundation Engineering — Chapter 13 Retaining Walls.": "Das, B. M., Principles of Foundation Engineering — Chapter 13 Retaining Walls.",
  // ── EN 1998-5 Ek F sismik taşıma gücü (Task 6) ───────────────────────
  "Depremli taşıma gücü yöntemi": "Seismic bearing capacity method",
  "TBDY Denk. 16.8a (hüküm)": "TBDY Eq. 16.8a (verdict)",
  "+ EN 1998-5 Ek F (bilgi amaçlı)": "+ EN 1998-5 Annex F (informative)",
  "Ek F seçilse de hüküm TBDY'de kalır; rapora ek bölüm girer": "Even with Annex F selected the verdict stays with TBDY; an extra report section is added",
  "γRd kategorisi (EN 1998-5 Tablo F.2)": "γRd category (EN 1998-5 Table F.2)",
  "Otomatik (φ, drenaj ve ön suya göre)": "Automatic (from φ, drainage and front water)",
  "Orta sıkı–sıkı kum (1,00)": "Medium-dense to dense sand (1.00)",
  "Gevşek kuru kum (1,15)": "Loose dry sand (1.15)",
  "Gevşek doygun kum (1,50)": "Loose saturated sand (1.50)",
  "Hassas olmayan kil (1,00)": "Non-sensitive clay (1.00)",
  "Hassas kil (1,15)": "Sensitive clay (1.15)",
  "Orta sıkı–sıkı kum": "Medium-dense to dense sand",
  "Gevşek kuru kum": "Loose dry sand",
  "Gevşek doygun kum": "Loose saturated sand",
  "Hassas olmayan kil": "Non-sensitive clay",
  "Hassas kil": "Sensitive clay",
  "11a. EN 1998-5 Ek F Sismik Taşıma Gücü (bilgi amaçlı)": "11a. EN 1998-5 Annex F Seismic Bearing Capacity (informative)",
  "Homojen zemin yüzeyindeki şerit temel için taşıma yüzeyi (Denk. F.1): N̄ = γRd·N/N_max, V̄ = γRd·V/N_max, M̄ = γRd·M/(B·N_max), F̄ zemin ataleti; f(N̄, V̄, M̄, F̄) < 0 ise bileşke taşıma yüzeyinin içindedir. Hüküm TBDY 2018 Denk. 16.8a ile verilir (bölüm 9 ve 11); bu bölüm yalnız bilgi amaçlıdır.":
    "Bearing surface for a strip footing at the surface of homogeneous soil (Eq. F.1): N̄ = γRd·N/N_max, V̄ = γRd·V/N_max, M̄ = γRd·M/(B·N_max), F̄ soil inertia; if f(N̄, V̄, M̄, F̄) < 0 the resultant lies inside the bearing surface. The verdict is given by TBDY 2018 Eq. 16.8a (sections 9 and 11); this section is informative only.",
  "Parametreler": "Parameters",
  "Zemin tipi (Tablo F.1 katsayı seti)": "Soil type (Table F.1 parameter set)",
  "kohezyonlu (drenajsız)": "cohesive (undrained)",
  "sürtünmeli (drenajlı)": "cohesionless (drained)",
  "Model kısmi katsayısı (Tablo F.2)": "Model partial factor (Table F.2)",
  "Tasarım kayma direnci açısı (tanφ′/1,25)": "Design angle of shearing resistance (tanφ′/1.25)",
  "Taşıma gücü faktörü": "Bearing capacity factor",
  "Tasarım drenajsız kayma dayanımı (cu/1,4)": "Design undrained shear strength (cu/1.4)",
  "Temel genişliği": "Foundation width",
  "Tasarım yer ivmesi × zemin katsayısı": "Design ground acceleration × soil factor",
  "N̄ üst sınırı": "N̄ upper bound",
  "✓ yüzey içinde": "✓ inside surface",
  "✗ yüzey dışında": "✗ outside surface",
  "N: net düşey kuvvet, V: devirici yatay kuvvetlerin toplamı, M = N·|e| (taban merkezine göre). N_max: sürtünmeli zeminde ½·γ·(1 ± av/g)·B²·Nγ (Denk. F.6), kohezyonlu zeminde (π+2)·cu,d·B (Denk. F.3); gömme derinliği ihmal edilmiştir. Malzeme kısmi katsayıları EN 1998-5 §3.1(3).":
    "N: net vertical force, V: sum of driving horizontal forces, M = N·|e| (about the base centre). N_max: ½·γ·(1 ± av/g)·B²·Nγ for cohesionless soil (Eq. F.6), (π+2)·cu,d·B for cohesive soil (Eq. F.3); embedment is ignored. Material partial factors per EN 1998-5 §3.1(3).",

  // ── Toptan göçme (şev stabilitesi) ─────────────────────────────────────
  "Toptan göçme": "Global stability",
  "Toptan göçme (şev stabilitesi) analizi": "Global stability (slope stability) analysis",
  "Dairesel kayma yüzeyi, dilim yöntemi; duvar gövdesi geçilmez blok. Ana hesaptan ayrı, arka planda çalışır.": "Circular slip surface, method of slices; the wall body is an impenetrable block. Runs in the background, separately from the main analysis.",
  "Bishop basitleştirilmiş (önerilen)": "Bishop simplified (recommended)",
  "Fellenius (İsveç dilim) — tutucu": "Fellenius (Swedish slices) — conservative",
  "Depremli durum": "Seismic case",
  "Statik-eşdeğer (aynı kh)": "Pseudo-static (same kh)",
  "Yalnız statik": "Static only",
  "kh Deprem sekmesindeki girdiden türetilir; kv uygulanmaz": "kh is derived from the Seismic tab input; kv is not applied",
  "Deprem sekmesinde hesap kapalı — yalnız statik": "Seismic analysis is off in the Seismic tab — static only",
  "Hedef GK (statik)": "Target FS (static)",
  "TBDY 16.6.2 pratiği: 1,5": "TBDY 16.6.2 practice: 1.5",
  "Hedef GK (depremli)": "Target FS (seismic)",
  "TBDY 16.12.1.4 pratiği: 1,1": "TBDY 16.12.1.4 practice: 1.1",
  "Dilim sayısı": "Number of slices",
  "Taban altı en az derinlik": "Minimum depth below base",
  "Daireler taban kotunun en az bu kadar altına iner": "Circles pass at least this far below the base level",
  "Merkez ızgarası otomatik (geometriden)": "Automatic centre grid (from geometry)",
  "x: burun − 0,5H … topuk + 2H; y: tepe + 0,25H … tepe + 3H; adım H/6; yarıçap adımı H/8": "x: toe − 0.5H … heel + 2H; y: top + 0.25H … top + 3H; step H/6; radius step H/8",
  "Merkez x en az": "Centre x min",
  "Merkez x en çok": "Centre x max",
  "Merkez y en az": "Centre y min",
  "Merkez y en çok": "Centre y max",
  "Izgara adımı": "Grid step",
  "Yarıçap adımı": "Radius step",
  "Toptan göçme sonucu": "Global stability result",
  "Hesaplanıyor…": "Computing…",
  "Kritik daire": "Critical circle",
  "daire": "circles",
  "merkez": "centre",
  "çıkış": "exit",
  "giriş": "entry",
  "daire denendi": "circles tried",
  "Dilim": "Slice",
  "Taban y (m)": "Base y (m)",
  "Yüzey y (m)": "Surface y (m)",
  "Temel zemini": "Foundation soil",
  "12a. Toptan Göçme (Şev Stabilitesi)": "12a. Global Stability (Slope Stability)",
  "Bu duvar için toptan göçme analizi kapalı.": "Global stability analysis is off for this wall.",
  "Yöntem ve tarama": "Method and search",
  "Bishop basitleştirilmiş (dilim yöntemi, dairesel yüzey)": "Bishop simplified (method of slices, circular surface)",
  "Fellenius / İsveç dilim yöntemi (dairesel yüzey)": "Fellenius / Swedish method of slices (circular surface)",
  "Merkez ızgarası x": "Centre grid x",
  "Merkez ızgarası y": "Centre grid y",
  "Izgara adımı / yarıçap adımı": "Grid step / radius step",
  "statik-eşdeğer": "pseudo-static",
  "hesaplanmadı": "not computed",
  "Güvenlik katsayıları": "Factors of safety",
  "Kaydıran ΣW·sinα (kN/m)": "Driving ΣW·sinα (kN/m)",
  "Direnç Σ(c·b + N′·tanφ)/mα (kN/m)": "Resisting Σ(c·b + N′·tanφ)/mα (kN/m)",
  "kritik kayma dairesi (statik)": "critical slip circle (static)",
  "Kritik daire dilimleri (statik, özet)": "Critical circle slices (static, summary)",
  "Kabuller: duvar gövdesi geçilmez blok (yüksek kayma direnci, ağırlığı dahil); taban altı ve ön zemin temel zemini parametreleriyle; dolgu tabakaları tepe kotundan; YASS altında u = γw·hw (drenajlı, efektif parametreler); sürşarj dolgu yüzeyinde; depremde kh·W yatay, kv yok. Şerit/çizgisel yükler dahil değildir.": "Assumptions: the wall body is an impenetrable block (high shear strength, weight included); below the base and in front the foundation soil parameters apply; backfill layers are measured from the top level; below the water table u = γw·hw (drained, effective parameters); surcharge on the backfill surface; in the seismic case kh·W horizontal, no kv. Strip/line loads are not included.",
  "Dolgu şeması": "Backfill schematic",
  "Temel zemini şeması": "Foundation soil schematic",
  "Su şeması": "Water schematic",
  "Yük şeması": "Load schematic",
  "Deprem şeması": "Seismic schematic",
  "δ = β (Rankine, sanal düzlem)": "δ = β (Rankine, virtual plane)",
  "Konsol/T duvar pratiği: itki dolgu eğimine paralel; EC7 örnekleriyle uyumlu": "Cantilever/T-wall practice: thrust parallel to the backfill slope; consistent with EC7 worked examples",
  "Geometri şeması": "Geometry schematic",
  // Plan 6 — betonarme konsol duvar
  "Betonarme payandalı duvar": "Reinforced concrete counterfort wall",
  "Betonarme konsol duvar": "Reinforced concrete cantilever wall",
  "Gövde yüksekliği": "Stem height",
  "Gövde üst / alt kalınlık": "Stem top / bottom thickness",
  "Taban kalınlığı": "Base slab thickness",
  "Burun / topuk uzunluğu": "Toe / heel length",
  "Kayma dişi derinlik / genişlik / burundan uzaklık": "Shear key depth / width / distance from toe",
  "Payanda aralık / kalınlık / üst genişlik": "Counterfort spacing / thickness / top width",
  "Beton / çelik / pas payı": "Concrete / steel / cover",
  "Gövde": "Stem",
  "Kalınlaşma ön yüzde (arka yüz düşey)": "Taper on the front face (back face vertical)",
  "Kapalıysa ön yüz düşey, arka yüz eğik": "If off, the front face is vertical and the back face battered",
  "Taban plağı": "Base slab",
  "Burun uzunluğu": "Toe length",
  "Topuk uzunluğu": "Heel length",
  "Kayma dişi": "Shear key",
  "Taban altında; pasif direnç derinliğini artırır (basitleştirilmiş)": "Below the base; increases the passive resistance depth (simplified)",
  "Diş derinliği": "Key depth",
  "Diş genişliği": "Key width",
  "Burundan uzaklık": "Distance from toe",
  "Payandalı duvar": "Counterfort wall",
  "Arka yüzde, topuk üstünde payandalar; gövde ve topuk plak olarak çalışır": "Counterforts on the back face above the heel; stem and heel act as slabs",
  "Payanda aralığı": "Counterfort spacing",
  "Payanda kalınlığı": "Counterfort thickness",
  "Payanda üst genişliği": "Counterfort top width",
  "0 = üçgen": "0 = triangular",
  "Taş ağırlık duvarı": "Masonry gravity wall",
  "Harçlı taş / beton; kademeli gövde": "Mortared stone / concrete; stepped body",
  "T/L kesit; kesit tasarımı ve donatı": "T/L section; section design and reinforcement",
  "Konsol + payandalar": "Cantilever + counterforts",
  "Duvar tipi": "Wall type",
  "Betonarme konsol duvar şeması": "RC cantilever wall schematic",
  "Beton sınıfı": "Concrete class",
  "Donatı çeliği": "Reinforcing steel",
  "Pas payı": "Cover",
  "Zeminle temas eden yüzeyler 5 cm (TS 500 §9.6)": "Surfaces in contact with soil 5 cm (TS 500 §9.6)",
  "Beton birim hacim ağırlığı": "Concrete unit weight",
  "Kesit tasarımı yönetmeliği": "Section design code",
  "Gövde kesit kotu aralığı": "Stem section level spacing",
  "Taban üstünden yukarı her bu kadar kotta kesit tasarımı": "Section design at every such level above the base slab",
  "Topuk tasarımında taban basıncı lehte sayılsın": "Include base pressure (favourable) in heel design",
  "Kapalı: taban basıncı ihmal (ACI ders notu pratiği; daha tutucu)": "Off: base pressure neglected (ACI lecture-note practice; more conservative)",
  "Gövde düşey ana donatı (arka yüz)": "Stem vertical main bars (back face)",
  "Gövde düşey ikincil (ön yüz)": "Stem vertical secondary (front face)",
  "Gövde yatay (her yüz)": "Stem horizontal (each face)",
  "Burun ana donatısı": "Toe main bars",
  "Topuk ana donatısı": "Heel main bars",
  "Taban boyuna dağıtma (her yüz)": "Base longitudinal distribution (each face)",
  "Otomatik seçim: gereken alanı sağlayan en küçük alanlı çap/aralık (aralık üst sınırı yönetmelikten). Elle seçim gereken alanı sağlamıyorsa kırmızı işaretlenir.": "Automatic selection: the diameter/spacing with the smallest area that provides the required area (maximum spacing per code). A manual choice that does not provide the required area is flagged in red.",
  "Donatı seçimi": "Reinforcement selection",
  "Konum": "Position",
  "Seçim": "Selection",
  "Gerekli": "Required",
  "Mevcut": "Provided",
  "Kesme kotu": "Cut-off level",
  "Elle": "Manual",
  "pas payı": "cover",
  "Beton · Çelik": "Concrete · Steel",
  "Donatı": "Reinforcement",
  "Burun": "Toe",
  "Topuk": "Heel",
  "Diş": "Key",
  "Kesit tasarımı": "Section design",
  "Md kNm/m · As gerekli mm²/m · çubuk oranı Md/Mr · V = Vd/Vr · * elle seçim": "Md kNm/m · As required mm²/m · bar = Md/Mr · V = Vd/Vr · * manual choice",
  "arka yüz": "back face",
  "ön yüz": "front face",
  "üst yüz": "top face",
  "alt yüz": "bottom face",
  "12a. Betonarme Kesit Tasarımı": "12a. Reinforced Concrete Section Design",
  "Gövde taban üstünden yukarı her kesit kotunda düşey konsol; burun ve topuk taban plağı konsolları (kesit gövde yüzünde). Kesit tesirleri kombinasyon × yük durumu ile faktörlü; taban basıncı faktörlü yüklerle yeniden hesaplanır (çekmesiz).": "The stem is a vertical cantilever at every section level above the base slab; toe and heel are base-slab cantilevers (section at the stem face). Section forces are factored per combination × load case; the base pressure is recomputed with factored loads (no tension).",
  "Tasarım durumları (faktörlü taban basıncı)": "Design cases (factored base pressure)",
  "Temas (m)": "Contact (m)",
  "Kesitler": "Sections",
  "Hükmeden": "Governing",
  "Alanlar mm²/m. * elle seçim. Eğilme:": "Areas in mm²/m. * manual choice. Flexure:",
  "Kesme:": "Shear:",
  "12b. Donatı Planı": "12b. Reinforcement Schedule",
  "Yüz": "Face",
  "Not": "Note",
  "Kenetlenme:": "Anchorage:",
  "Şema ölçekli değildir; çubuk sayısı temsilîdir.": "The sketch is not to scale; the number of bars is representative.",
  "Donatı şeması": "Reinforcement sketch",
  "Arya, C., Design of Structures to BS 8110 (Örnek 3.16 konsol istinat duvarı — doğrulama); CE 437/537 Retaining Wall Design Example (ACI 318 — doğrulama).": "Arya, C., Design of Structures to BS 8110 (Example 3.16 cantilever retaining wall — verification); CE 437/537 Retaining Wall Design Example (ACI 318 — verification).",
  "İç kesitler / kesit tasarımı": "Internal sections / section design",
  "Betonarme kesit tasarımı (betonarme duvarda)": "RC section design (RC walls)",
  "Donatı planı ve şeması (betonarme duvarda)": "Reinforcement schedule and sketch (RC walls)",
  "Payandalı duvar — plaklar ve payanda": "Counterfort wall — slabs and counterfort",
  "kalınlık": "thickness",
  "temiz açıklık": "clear span",
  "Gövde plağı kotu": "Stem slab level",
  "Topuk plağı: en büyük net yük": "Heel slab: maximum net load",
  "Gövde alt şerit düşey konsol": "Stem bottom strip vertical cantilever",
  "Bağlantı donatıları:": "Tie reinforcement:",
  "Plak kesitleri (gövde/topuk mesnet ve açıklık) donatı planında listelenir.": "Slab sections (stem/heel support and midspan) are listed in the reinforcement schedule.",
  "Gövde düşey şerit": "Stem vertical strip",
  "Payanda": "Counterfort",
  "Gövde plağı": "Stem slab",
  "Topuk plağı": "Heel slab",
  "Payandalı: gövde/topuk plak": "Counterfort: stem/heel slab",
  "topuk": "heel",
  "adet": "pcs",
  "13. Metraj": "13. Quantities",
  "Miktarlar 1 m duvar uzunluğu için kesit geometrisinden; toplam duvar boyu": "Quantities per 1 m of wall from the section geometry; total wall length",
  "Bilgi satırları (↳) keşfe girmez.": "Information rows (↳) are not priced.",
  "İmalat": "Item",
  "1 m için": "Per 1 m",
  "Toplam": "Total",
  "Donatı metrajı": "Reinforcement take-off",
  "Adet / m": "Bars / m",
  "Boy (m)": "Length (m)",
  "Toplam (kg)": "Total (kg)",
  "Boy hesabı": "Length basis",
  "Çap": "Diameter",
  "Kabuller": "Assumptions",
  "13b. Keşif Özeti": "13b. Cost Estimate",
  "Toplam miktarlar rapordaki duvarların toplamıdır": "Total quantities are the sum over the walls in this report",
  "Birim fiyatlar KDV hariç; poz numaraları güncel ÇŞB birim fiyat listesiyle doğrulanmalıdır.": "Unit prices exclude VAT; item codes should be verified against the current Ministry (ÇŞB) unit price list.",
  "Fiyat yılı:": "Price year:",
  "Poz no": "Item code",
  "Miktar": "Quantity",
  "Birim fiyat": "Unit price",
  "Toplam (KDV hariç)": "Total (excl. VAT)",
  "Birim fiyatı girilmemiş pozlar toplama dâhil değildir:": "Items without a unit price are excluded from the total:",
  "Metraj ve keşif": "Quantities and cost estimate",
  "0 = grobeton yok; her yanda taşma": "0 = no blinding; overhang each side",
  "0,10 = %10": "0.10 = 10 %",
  "Arka yüz boyunca; 0 = yok": "Along the back face; 0 = none",
  "Ayrıntı ve keşif özeti raporda (13 / 13b).": "Details and cost estimate in the report (13 / 13b).",
  "Barbakan aralığı": "Weep-hole spacing",
  "Barbakan çapı": "Weep-hole diameter",
  "Donatı bindirme + fire payı": "Rebar lap + waste allowance",
  "Drenaj borusu çapı": "Drain pipe diameter",
  "Drenaj metrajı": "Drainage quantities",
  "Duvar boyu": "Wall length",
  "Filtre kalınlığı": "Filter thickness",
  "Fire payı (taş / beton / harç)": "Waste allowance (stone / concrete / mortar)",
  "Fiyat yılı / kaynak": "Price year / source",
  "Gevşek hacim / duvar içindeki taş hacmi": "Loose volume / stone volume in the wall",
  "Grobeton kalınlığı": "Blinding thickness",
  "Grobeton taşması": "Blinding overhang",
  "Harç hacim oranı": "Mortar volume ratio",
  "KDV hariç": "excl. VAT",
  "Kazı şevi": "Cut slope",
  "Metraj": "Quantities",
  "Metraj sonuç panelinde ve raporun 13. bölümünde; XLSX / CSV indirme rapor ekranında ve sonuç panelinde.": "Quantities appear in the results panel and report section 13; XLSX / CSV download on the report screen and in the results panel.",
  "Metraj varsayılanlarına dön": "Reset quantity defaults",
  "Metraj ve keşif (CSV)": "Quantities and cost estimate (CSV)",
  "Metraj ve keşif (Excel)": "Quantities and cost estimate (Excel)",
  "Metraj özeti": "Quantities summary",
  "Metraj — poz ve birim fiyat varsayılanları": "Quantities — item code and unit price defaults",
  "Moloz taş 0,30–0,35; kaba yonu 0,25 (bilgi satırı)": "Rubble 0.30–0.35; rough-dressed 0.25 (information row)",
  "Ocak taşı kabarma katsayısı": "Quarry stone bulking factor",
  "Para birimi": "Currency",
  "Poz numaraları ÇŞB (2018 sonrası) numaralamasına göre örnektir; güncel yıl listesiyle doğrulayın. Fiyatı boş bırakılan poz keşif toplamına girmez.": "Item codes follow the Ministry (ÇŞB, post-2018) numbering as examples; verify against the current year's list. Items with no price are excluded from the total.",
  "Poz ve birim fiyat tablosu": "Item code and unit price table",
  "Poz ve birim fiyat tablosu…": "Item code and unit price table…",
  "Poz ve birim fiyat varsayılanları": "Item code and unit price defaults",
  "Proje ile birlikte kaydedilir; keşif özeti (rapor 13b, XLSX) bu tabloyla hesaplanır.": "Saved with the project; the cost estimate (report 13b, XLSX) uses this table.",
  "Salt okunur proje": "Read-only project",
  "Sağlayıcı varsayılanlarına dön": "Reset to provider defaults",
  "Sıra sayısı ≈ istinat yüksekliği / 2 m": "Rows ≈ retained height / 2 m",
  "Temel kenarından kazı tabanına": "From footing edge at the excavation base",
  "Toplam metraj = 1 m × L; 3B görünüm de bu boyu kullanır": "Total = 1 m × L; the 3D view also uses this length",
  "Topuk boyunca drenaj borusu, arka yüz filtre malzemesi, barbakanlar": "Drain pipe along the heel, back-face filter material, weep holes",
  "Yatay / düşey; arka doğal zemin duvar tepesi kotunda kabul edilir": "Horizontal / vertical; natural ground behind assumed at wall top level",
  "Yeni projelere kopyalanır; proje içinde ayrıca düzenlenebilir.": "Copied to new projects; editable within each project.",
  "donatı": "rebar",
  "Çalışma payı": "Working space",
  "ÇŞB pozlarında fire birim fiyata dâhildir → 0": "Waste is included in ÇŞB unit prices → 0",
  "ör. 2025 ÇŞB": "e.g. 2025 ÇŞB",
  "Dik (0)": "Vertical (0)",
  "1/2 (0,5 yatay / 1 düşey)": "1/2 (0.5 horizontal / 1 vertical)",
  "1/1 (45°)": "1/1 (45°)",
  "Lütfen kontrol edin:": "Please check:",
  "poz numaraları, tanımlar ve birim fiyatlar örnektir; pozlar ve fiyatlar yıllara göre değişebilmektedir. Tablodaki her hücre (poz no, tanım, birim, fiyat) düzenlenebilir — hatalı satırları buradan düzeltin.": "item codes, descriptions and unit prices are examples; codes and prices change from year to year. Every cell (code, description, unit, price) is editable — correct wrong rows here.",
  "Keşif notu (raporda, XLSX/CSV ve Word'de basılır)": "Cost estimate note (printed in the report, XLSX/CSV and Word)",
  "Fiyatı boş bırakılan poz keşif toplamına girmez. Birim boşsa metraj birimi kullanılır.": "Items with no price are excluded from the total. An empty unit falls back to the take-off unit.",
  "Birim fiyatlar KDV hariç.": "Unit prices exclude VAT.",
  "Not:": "Note:",
  "Birim fiyatlar ÇŞB Yüksek Fen Kurulu 2026 Temmuz ayı güncel inşaat birim fiyat listesinden alınmıştır (%25 yüklenici kârı ve genel giderler dâhil, KDV hariç). Liste TÜİK endeksleriyle her ay güncellenir; iş programınıza uyan ayın resmî listesiyle kontrol edip poz tablosundan güncelleyin.": "Unit prices are taken from the Turkish Ministry (ÇŞB) High Technical Board July 2026 current construction unit price list (25% contractor profit and overheads included, VAT excluded). The list is updated monthly with TÜİK indices; check it against the official list for the month that matches your schedule and update the item table.",
  // Payanda plan görünümü
  "Payanda plan görünümü": "Counterfort plan view",
  "gövde": "stem",
  "burun": "toe",
  "Plan görünümü (payandalar)": "Plan view (counterforts)",
  "Plan görünümü yalnız payandalı duvarda çizilir.": "The plan view is drawn only for counterfort walls.",
  // Zemin etüt raporundan çıkarma (Gemini)
  "Taşıma gücü · taban sürtünmesi": "Bearing capacity · base friction",
  "Yeraltı suyu": "Groundwater",
  "Dosya 20 MB sınırını aşıyor.": "The file exceeds the 20 MB limit.",
  "Bu özellik için aktif abonelik gerekir.": "This feature requires an active subscription.",
  "Saatlik çıkarma sınırına ulaştınız; biraz sonra deneyin.": "Hourly extraction limit reached; try again later.",
  "Zemin etüt raporundan al": "Import from soil report",
  "Yapay zekâ (Google Gemini) raporu okur; değerler onayınızla yazılır.": "AI (Google Gemini) reads the report; values are written only with your approval.",
  "Rapor dosyası (PDF; taranmış PDF de olur)": "Report file (PDF; scanned PDFs work too)",
  "Rapor dosyası": "Report file",
  "Not (isteğe bağlı) — ör. hangi sondaj / hangi tabaka": "Note (optional) — e.g. which borehole / which layer",
  "SK-2 sondajı, temel 2,0 m'de": "Borehole BH-2, footing at 2.0 m",
  "Dosya yalnız bu çıkarma için sunucuya ve Google'a gönderilir, saklanmaz. Kişisel veri içeren sayfaları göndermeden çıkarabilirsiniz.": "The file is sent to the server and Google only for this extraction and is not stored. You may remove pages with personal data before uploading.",
  "Okunuyor… (30–90 sn)": "Reading… (30–90 s)",
  "Raporu oku": "Read report",
  "Başlık yok": "No title",
  "sayfa": "pages",
  "süre": "time",
  "Temel zemini olarak alınacak tabaka": "Layer to use as foundation soil",
  "Raporda tabaka tablosu bulunamadı.": "No layer table was found in the report.",
  "Yeraltı suyu derinliği referansı": "Groundwater depth reference",
  "Dolgu üst yüzeyi (arka zemin)": "Backfill surface (retained ground)",
  "Ön zemin": "Front ground",
  "Sondaj ağzı hangi kotta ise onu seçin": "Choose the level of the borehole mouth",
  "Çıkarılan değerler": "Extracted values",
  "Alan": "Field",
  "Önerilen": "Proposed",
  "uygula": "apply",
  "Uyarılar": "Warnings",
  "Projedeki tüm duvarlara uygula": "Apply to all walls in the project",
  "Başka dosya": "Another file",
  "Seçilenleri uygula": "Apply selected",
  "hesapla": "computed",
  "ön zemin": "front ground",
  "dolgu üst yüzeyi": "backfill surface",
  "tabandan": "from base",
  "taban altında → su yok": "below base → no water",
  "Arka YASS": "Back groundwater level",
  "yok": "none",
  "zemin sınıfı": "site class",
  "Zemin sınıfı": "Site class",
  "ZF: sahaya özel analiz; uygulanmaz": "ZF: site-specific analysis; not applied",
  // Rapor kapağı özelleştirme
  "BETONARME PAYANDALI İSTİNAT DUVARI": "REINFORCED CONCRETE COUNTERFORT RETAINING WALL",
  "BETONARME KONSOL İSTİNAT DUVARI": "REINFORCED CONCRETE CANTILEVER RETAINING WALL",
  "İSTİNAT DUVARLARI": "RETAINING WALLS",
  "Belge no": "Document no",
  "Rapor kapağı": "Report cover",
  "başlık, firma, logo, belge no (isteğe bağlı)": "title, firm, logo, document no (optional)",
  "Rapor başlığı": "Report title",
  "Üst başlık": "Heading line",
  "Duvar tipine göre otomatik": "Automatic from wall type",
  "Firma adı": "Firm name",
  "Firma adresi": "Firm address",
  "Telefon": "Phone",
  "Kapak logosu": "Cover logo",
  "PNG/JPEG, ≤ 300 KB; boşsa sağlayıcı logosu": "PNG/JPEG, ≤ 300 KB; provider logo if empty",
  "Logo en fazla 300 KB olmalı.": "Logo must be at most 300 KB.",
  "Kapak notu": "Cover note",
  "İmza kutuları": "Signature boxes",
  "Kapakta proje müellifi / kontrol eden kutuları": "Designer / reviewer boxes on the cover",
  // Mesafeli satış onayı ve satıcı bilgileri
  "Sözleşme onayı": "Contract consent",
  "Ön Bilgilendirme Formu": "Pre-Information Form",
  "'nu ve": " and the",
  "Mesafeli Satış Sözleşmesi": "Distance Sales Agreement",
  "'ni okudum, kabul ediyorum; hizmetin cayma süresi dolmadan hemen başlamasını istiyorum.": " — I have read and accept them, and I request the service to start immediately, before the withdrawal period ends.",
  "Satıcı bilgileri (ön bilgilendirme formu ve mesafeli satış sözleşmesinde basılır)": "Seller details (printed on the pre-information form and distance sales agreement)",
  "Ticaret unvanı / ad soyad": "Trade name / full name",
  "Adres": "Address",
  "Vergi dairesi": "Tax office",
  "Vergi no / TCKN": "Tax no / ID no",
  "Ön bilgilendirme": "Pre-information",
  "Mesafeli satış": "Distance sales",
  // Hesap: fatura bilgileri
  "Profil ve fatura bilgileri": "Profile and billing details",
  "Düzenle": "Edit",
  "Fatura:": "Invoice:",
  "Kurumsal": "Company",
  "Bireysel": "Individual",
  "girilmedi — fatura için gerekli": "not entered — required for invoicing",
  "Kaydedildi.": "Saved.",
  "Ad soyad": "Full name",
  "Fatura bilgileri": "Billing details",
  "ödeme onayında fatura bu bilgilerle kesilir": "invoices are issued with these details when a payment is confirmed",
  "Fatura türü": "Invoice type",
  "Bireysel (TCKN)": "Individual (ID no)",
  "Kurumsal (vergi no)": "Company (tax no)",
  "Ticaret unvanı": "Trade name",
  "Ad soyad (faturada)": "Full name (on invoice)",
  "Vergi no": "Tax no",
  "Fatura adresi": "Billing address",
  "E-fatura / e-arşiv e-postası": "E-invoice e-mail",
  "fatura bilgisi yok": "no billing details",
  // Ana sayfa vitrini ve kılavuz
  "Kesiti girin": "Enter the section",
  "Duvar tipini seçin (taş ağırlık, betonarme konsol, payandalı), ölçüleri çizim üzerinde tıklayıp düzenleyin; zemin, su, yük ve deprem sekmelerini doldurun — ya da zemin etüt raporunu yükleyip değerleri yapay zekâya okutun.": "Pick the wall type (stone gravity, RC cantilever, counterfort), click dimensions on the drawing to edit them; fill in soil, water, load and seismic tabs — or upload the soil report and let AI read the values.",
  "Kesit çizimi: ölçüler, kuvvetler ve basınç diyagramı": "Section drawing: dimensions, forces and pressure diagram",
  "Hükümleri anında görün": "See the verdicts instantly",
  "Devrilme, kayma, taşıma gücü, dış merkezlilik; betonarmede kesit tasarımı ve donatı; isteğe bağlı toptan göçme. Her girdi değişiminde sonuçlar ve 3B görünüm yenilenir.": "Overturning, sliding, bearing, eccentricity; section design and reinforcement for RC walls; optional global stability. Results and the 3D view refresh on every input change.",
  "3B görünüm: duvar, dolgu ve kuvvet okları": "3D view: wall, backfill and force arrows",
  "Raporu alın": "Get the report",
  "Kurumlara sunulabilir Türkçe/İngilizce rapor: kapak, girdiler, ölçülü kesit, kuvvet şeması, adım adım hesap, donatı planı, metraj ve keşif. PDF, Word, DXF ve XLSX.": "A Turkish/English report ready for authorities: cover, inputs, dimensioned section, force diagram, step-by-step calculation, reinforcement plan, quantities and cost. PDF, Word, DXF and XLSX.",
  "Rapor kapağı ve hesap sayfaları": "Report cover and calculation pages",
  "Nasıl çalışır": "How it works",
  "Nasıl çalışır?": "How does it work?",
  "Payandalı betonarme duvar: donatı şeması ve payanda izi": "RC counterfort wall: reinforcement scheme and counterfort trace",
  "Payandalı betonarme duvarda donatı şeması, plan görünümü ve payanda kesit tasarımı (TS 500 / EC2 / ACI 318).": "Reinforcement scheme, plan view and counterfort section design for RC counterfort walls (TS 500 / EC2 / ACI 318).",
  "Planlar ve fiyatlar": "Plans and pricing",
  "14 gün ücretsiz deneyin": "Try free for 14 days",
  "Hesap açınca tüm özellikler 14 gün açık (raporda deneme filigranı). Sonrasında aylık ya da yıllık abonelik; süre dolunca projeleriniz silinmez, salt okunur kalır ve JSON olarak indirilebilir. Havale/EFT ya da kartla ödeme.": "All features are open for 14 days after sign-up (trial watermark on reports). Then a monthly or yearly subscription; when it ends your projects are kept read-only and downloadable as JSON. Pay by bank transfer or card.",
  "Kullanım kılavuzu": "User guide",
  "ay": "month",
  "KDV dâhil": "VAT included",
  "Fiyatlar yakında.": "Prices coming soon.",
  "Üç duvar tipi": "Three wall types",
  "Taş (kargir) ağırlık, betonarme konsol (T/L) ve payandalı duvar. Betonarmede TS 500 / EN 1992-1-1 / ACI 318-19 ile kesit tasarımı, en ekonomik donatı seçimi ve donatı planı.": "Stone (masonry) gravity, RC cantilever (T/L) and counterfort walls. RC section design to TS 500 / EN 1992-1-1 / ACI 318-19 with most economical bar selection and reinforcement plan.",
  "Mononobe-Okabe ile statik + dinamik itki, duvar ve kama ataleti, kh/kv doğrudan girişi; her adımın formülü ve yerine konmuş sayıları raporda. TBDY'nin kendi örneğiyle doğrulandı.": "Static + dynamic thrust with Mononobe-Okabe, wall and wedge inertia, direct kh/kv input; every step's formula and substituted numbers in the report. Verified against TBDY's own worked example.",
  "Kazı, dolgu, taş/beton, kalıp, donatı (kg) ve drenaj metrajı; ÇŞB poz numaralı, düzenlenebilir birim fiyat tablosu; keşif özeti XLSX/CSV ve raporda.": "Excavation, backfill, stone/concrete, formwork, rebar (kg) and drainage take-off; editable unit price table with Ministry item codes; cost summary as XLSX/CSV and in the report.",
  "Zemin raporundan al": "Import from soil report",
  "Zemin etüt raporunu (PDF) yükleyin; yapay zekâ tabaka parametrelerini, taşıma gücünü, yeraltı suyunu ve deprem katsayılarını sayfa referansıyla önerir — siz onaylarsınız.": "Upload the geotechnical report (PDF); AI proposes layer parameters, bearing capacity, groundwater and seismic coefficients with page references — you approve.",
  "İstinat duvarı hesabı, kesitten rapora.": "Retaining wall design, from section to report.",
  "Taş ağırlık, betonarme konsol ve payandalı duvarlar için TBDY 2018, Eurocode 7 ve ABD pratiğine göre devrilme, kayma, taşıma gücü ve kesit tasarımı; metraj, keşif ve kurumlara sunulabilir rapor. Girdiyi değiştirdiğiniz anda kesit ve hükümler yenilenir.": "Overturning, sliding, bearing and section design for stone gravity, RC cantilever and counterfort walls to TBDY 2018, Eurocode 7 and US practice; quantities, cost and a report ready for authorities. The section and verdicts refresh as you type.",
  "Örnek projeyle dene": "Try the sample project",
  // CAD kabuğu (design_handoff_cad_arayuz): şerit, paletler, komut satırı, durum çubuğu
  "Komut listesi": "Command list",
  "Komut satırına yazın; boş Enter son komutu yineler, Esc temizler, Tab ilk öneriyi tamamlar. Büyük/küçük harf fark etmez.": "Type in the command line; empty Enter repeats the last command, Esc clears, Tab completes the first suggestion. Case-insensitive.",
  "Komut": "Command",
  "Ne yapar": "What it does",
  "Geri al": "Undo",
  "Yinele": "Redo",
  "Geri al (Ctrl+Z)": "Undo (Ctrl+Z)",
  "Raporda bina temeli için verilmiş — istinat duvarı için kontrol edin": "Given in the report for a building foundation — check it for the retaining wall",
  "Belgede okunabilir metin yok (taranmış PDF olabilir) — değerleri elle girin.": "The document has no readable text (it may be a scanned PDF) — enter the values manually.",
  "Eski Word biçimi (.doc) okunamıyor; dosyayı Word'de .docx ya da PDF olarak kaydedip yükleyin.": "The old Word format (.doc) cannot be read; save the file as .docx or PDF in Word and upload it.",
  "Yalnız PDF ya da Word (.docx) okunabilir; görsel ya da taranmış belgede değerleri elle girin.": "Only PDF or Word (.docx) can be read; for images or scanned documents enter the values manually.",
  "Word dosyası okunamadı": "The Word file could not be read",
  "PDF okunamadı: okuma zaman aşımına uğradı. Sayfayı yenileyip tekrar deneyin; sürerse değerleri elle girin.": "The PDF could not be read: reading timed out. Reload the page and try again; if it persists, enter the values manually.",
  "PDF şifreli; şifresiz kopyasını yükleyin.": "The PDF is password-protected; upload an unprotected copy.",
  "PDF bozuk ya da geçersiz; dosyayı yeniden kaydedip yükleyin.": "The PDF is corrupt or invalid; save it again and upload.",
  "bilinmeyen hata": "unknown error",
  "SS ve S1 birlikte, sıfırdan büyük girilmeli": "Enter SS and S1 together, both greater than zero",
  "SS en çok 3, S1 en çok 1,5 olabilir (TDTH)": "SS may be at most 3 and S1 at most 1.5 (TDTH)",
  "Deprem (TBDY 2018)": "Seismic (TBDY 2018)",
  "Deprem hesabı yapılsın": "Include seismic analysis",
  "SS (kısa periyot)": "SS (short period)",
  "ör. 0,85": "e.g. 0.85",
  "S1 (1 s periyot)": "S1 (1 s period)",
  "ör. 0,24": "e.g. 0.24",
  "SS ve S1'i proje koordinatı için": "Take SS and S1 for the project coordinates from the",
  "AFAD Deprem Tehlike Haritası": "AFAD seismic hazard map",
  "sayfasından (DD-2, %10 / 50 yıl) alın; zemin sınıfı zemin etüdünden.": "(DD-2, 10% in 50 years); the site class comes from the soil report.",
  "Boş bırakılırsa SS 1,00 · S1 0,25 · ZC kullanılır (yüksek deprem varsayımı) — duvar gereğinden büyük çıkabilir. Sonradan Model › Deprem'den değiştirilebilir.": "If left blank, SS 1.00 · S1 0.25 · ZC is used (high-seismicity assumption) — the wall may come out larger than needed. You can change it later in Model › Seismic.",
  "varsayılan değer, konumun AFAD değerini girin": "default value, enter the AFAD value for the site",
  "Enter yeni satır · Ctrl+Enter bitir · Esc vazgeç": "Enter new line · Ctrl+Enter finish · Esc cancel",
  "Ölçü stili": "Dimension style",
  "Ölçü yazısı": "Dimension text",
  "Kâğıtta yükseklik": "Height on paper",
  "Ok boyu": "Arrow size",
  "Ondalık": "Decimals",
  "Birime göre (cm 0, m 2)": "By unit (cm 0, m 2)",
  "Bu adla katman var": "A layer with this name exists",
  "Katman adı girin": "Enter a layer name",
  "Katmanlar": "Layers",
  "Standart katmanlar (DUVAR, OLCU, YAZI…) sabittir. Eklediğiniz katmanlar DXF'e yazılır; seçili öğeyi şeritteki Katman listesinden taşıyın.": "Standard layers (DUVAR, OLCU, YAZI…) are fixed. Layers you add are written to the DXF; move the selected object with the ribbon's Layer list.",
  "rengi": "colour",
  "katmanını sil": "— delete layer",
  "Yeni katman adı": "New layer name",
  "Yeni katman rengi": "New layer colour",
  "Yinele (Ctrl+Y)": "Redo (Ctrl+Y)",
  "Seçenekler": "Options",
  "Komutlar": "Commands",
  "Pafta sekmeleri": "Sheet tabs",
  "Başlangıç": "Start",
  "Projeyi kapat": "Close project",
  "Durum çubuğu": "Status bar",
  "Salt okunur paylaşım": "Read-only share",
  "salt okunur": "read-only",
  "Ölçek": "Scale",
  "Birim: m · kN": "Units: m · kN",
  "Komut satırı": "Command line",
  "Komut satırı hazır — YARDIM yazın.": "Command line ready — type HELP.",
  "salt okunur paylaşım — komut girilemez": "read-only share — commands disabled",
  "komut veya değer girin — YARDIM": "enter a command or value — HELP",
  "Ad": "Name",
  "Renk": "Color",
  "Çizgi tipi": "Linetype",
  "Sağa yerleştir": "Dock right",
  "Yüzen palet": "Floating palette",
  "Sonuçları kapat": "Close results",
  "Özellikleri daralt": "Collapse properties",
  "Hücreye tıklayıp değer girin · alan odaklanınca ilgili ölçü çizimde vurgulanır": "Click a cell to edit · the matching dimension is highlighted in the drawing when a field is focused",
  "Model alanı": "Model space",
  "Zoom extents": "Zoom extents",
  "Kaydır": "Pan",
  "Kaydır (sürükle)": "Pan (drag)",
  "Katman yöneticisi": "Layer manager",
  "Pafta düzeni": "Layout",
  "Model": "Model",
  "Katman yöneticisini kapat": "Close layer manager",
  "Geçerli katman": "Current layer",
  "Zemin ve Yük": "Soil & Loads",
  "Analiz": "Analysis",
  "Çıktı": "Output",
  "Şerit sekmeleri": "Ribbon tabs",
  "Taş": "Stone",
  "ağırlık": "gravity",
  "Taş ağırlık duvarı ekle": "Add stone gravity wall",
  "konsol": "cantilever",
  "Betonarme konsol duvar ekle": "Add RC cantilever wall",
  "Payan-": "Counter-",
  "dalı": "fort",
  "Payandalı duvar ekle": "Add counterfort wall",
  "Seçili duvarı kopyala": "Copy selected wall",
  "Seçili duvarı sil": "Delete selected wall",
  "Yeniden adlandır": "Rename",
  "Duvar adı": "Wall name",
  "Seçili duvarı yeniden adlandır": "Rename selected wall",
  "Otomatik boyutlandırma ve karşılaştırma": "Automatic sizing and comparison",
  "Otomatik": "Automatic",
  "boyutlandır": "sizing",
  "Ön boyutlandırma": "Preliminary sizing",
  "Yalnız duvar yüksekliğini (ve varsa sürşarjı) verin; zemin, dolgu, su, deprem ve malzeme ayarları seçili duvardan alınır. Her tip için tüm kontrolleri sağlayan en ucuz boyut aranır ve 1 m duvar maliyetiyle karşılaştırılır.": "Enter only the wall height (and the surcharge if any); soil, backfill, water, seismic and material settings are taken from the selected wall. For each type the cheapest size that satisfies every check is searched and compared by the cost of 1 m of wall.",
  "Duvar yüksekliği": "Wall height",
  "Sürşarj": "Surcharge",
  "Ön zeminin kaymaya katkısı": "Contribution of the front soil to sliding resistance",
  "Taş (kargir) ağırlık": "Stone (masonry) gravity",
  "Betonarme konsol": "RC cantilever",
  "Hesapla": "Calculate",
  "Boyutlar taranıyor…": "Scanning sizes…",
  "Seçileni duvara uygula": "Apply the selection to the wall",
  "Boyutlandırma karşılaştırması": "Sizing comparison",
  "Tip": "Type",
  "Boyutlar (m)": "Dimensions (m)",
  "1 m metrajı": "Quantities per 1 m",
  "1 m maliyeti": "Cost per 1 m",
  "En zorlayan kontrol": "Governing check",
  "en ekonomik": "most economical",
  "Taş (kargir) ağırlık duvar": "Stone (masonry) gravity wall",
  "Taban genişliği B": "Base width B",
  "Ön yüz eğimi (yatay/düşey)": "Front face batter (horizontal/vertical)",
  "Temel bloğu yüksekliği": "Foundation block height",
  "Burun / topuk çıkıntısı": "Toe / heel projection",
  "Gövde üst kalınlığı": "Stem top thickness",
  "Gövde alt kalınlığı": "Stem bottom thickness",
  "Taban plağı kalınlığı": "Base slab thickness",
  "Kayma dişi derinliği": "Shear key depth",
  "Taş duvar": "Stone masonry",
  "Beton": "Concrete",
  "Kalıp": "Formwork",
  "Kazı": "Excavation",
  "boyut denendi": "sizes tried",
  "Birim fiyatlar Metraj › Poz tablosundan gelir; varsayılanlar yaklaşık tahmindir, güncel ÇŞB listesiyle kontrol edin. Öneri tavsiye niteliğindedir; uygulandıktan sonra hesap ve rapor normal akışta yeniden yapılır.": "Unit prices come from Quantities › item table; the defaults are rough estimates, check them against the current ministry list. The suggestion is advisory; once applied, the analysis and report are produced again in the normal flow.",
  "Çizim": "Drawing",
  "Ölçü": "Dimension",
  "Ölçü katmanı": "Dimension layer",
  "Katman": "Layers",
  "Çıkış ve gezinme": "Output & navigation",
  "Başlangıç sayfası": "Start page",
  "Kademe sil": "Remove step",
  "Geometri düzenleme": "Geometry editing",
  "Çokgen kesit": "Polygon section",
  "Ölçü düzenle": "Edit dimension",
  "Betonarme ve temel": "RC & foundation",
  "Dolgu ve yükler": "Backfill & loads",
  "Dolgu tabakası": "Backfill layer",
  "Sürşarj q": "Surcharge q",
  "YASS su": "Water table",
  "Çizgi yük": "Line load",
  "Şev açısı β": "Slope angle β",
  "Yapay zekâ": "AI",
  "Hesap profili": "Design profile",
  "Deprem girişi": "Seismic input",
  "Deprem giriş yöntemi": "Seismic input method",
  "Haritadan (SS, S1)": "From map (SS, S1)",
  "kh / kv doğrudan": "kh / kv direct",
  "İtki yöntemi": "Pressure method",
  "Sanal düzlem (topuk)": "Virtual plane (heel)",
  "Arka yüz (Coulomb)": "Back face (Coulomb)",
  "Araçlar": "Tools",
  "Hesabı yenile": "Recalculate",
  "Hesap eşzamanlı — her girdi değişiminde yenilenir.": "Analysis is live — it refreshes on every input change.",
  "Klasik GK tablosu": "Classic FS table",
  "EC8 Ek F": "EC8 Annex F",
  "Belge": "Document",
  "PDF (rapor paftası)": "PDF (report sheet)",
  "Word (rapor paftası)": "Word (report sheet)",
  "DXF indir": "Download DXF",
  "Tablo ve veri": "Tables & data",
  "XLSX (metraj)": "XLSX (quantities)",
  "Yazdır": "Print",
  "Çıktı ayarı": "Output settings",
  "Rapor hazır ayarı": "Report preset",
  "Yeterli": "Standard",
  "Özet": "Summary",
  "Detaylı": "Detailed",
  "Özel": "Custom",
  "Dil": "Language",
  "Arayüz dili": "Interface language",
  "Sağlayıcı ayarı (Seçenekler)": "Provider setting (Options)",
  "paftası": "sheet",
  "açık": "on",
  "kapalı": "off",
  "yakala": "snap",
  "İmleç koordinatı": "Cursor coordinate",
  "Kaydırma kipi (orta tuş / boş alanda sürükleme her zaman kaydırır)": "Pan mode (middle button / dragging empty space always pans)",
  "Kontrol tablosu": "Check table",
  "Yük durumu": "Load case",
  "Metraj girdileri": "Quantity inputs",
  "Metraj tablosu": "Quantity table",
  "Metraj paftası": "Quantities sheet",
  "Metraj — 1 m ve toplam": "Quantities — per 1 m and total",
  "bilgi": "info",
  "Donatı metrajı (poz)": "Rebar quantities (by position)",
  "Poz": "Position",
  "adet/m": "pcs/m",
  "Boy": "Length",
  "fiyat yılı": "price year",
  "girilmedi": "not set",
  "poz fiyatsız": "items unpriced",
  "Fiyatı boş bırakılan poz keşif toplamına girmez → keşif özeti (rapor 13b) şimdilik hesaplanamıyor.": "Unpriced items are excluded from the estimate → cost summary (report 13b) cannot be computed yet.",
  "← Model": "← Model",
  "← Paylaşım": "← Share",
  "Seçenekler — Hesabım": "Options — My account",
  "Seçenekler — Sağlayıcı paneli": "Options — Provider panel",
  "Kategoriler": "Categories",
  "Belgeler": "Documents",
  "BELGE": "DOCUMENT",
  "Sürüm": "Version",
  "indirme": "download",
  "Seçenekler — Abonelik · Planlar": "Options — Subscription · Plans",
  "Dahil olanlar": "Included",
  "Dönem": "Period",
  "Fiyat": "Price",
  "dâhil": "included",
  "Projeyi JSON indir": "Download project JSON",
  "Pencereyi kapat": "Close window",
  "Klavye kısayolları": "Keyboard shortcuts",
  "Diyaloğu kapat / kaydırma kipinden çık": "Close dialog / leave pan mode",
  "Projeyi JSON olarak kaydet": "Save project as JSON",
  "Model · Metraj · Rapor paftası": "Model · Quantities · Report sheet",
  "Model alanını kaydır": "Pan the model space",
  "Yakınlaştır / uzaklaştır": "Zoom in / out",
  "Sığdır (zoom extents)": "Fit (zoom extents)",
  "Odak boştayken komut satırına yazmaya başlar": "Starts typing in the command line when nothing is focused",
  "Son komutu yineler": "Repeats the last command",
  "İlk komut önerisini tamamlar": "Completes the first command suggestion",
  "Metraj paftasını aç": "Open quantities sheet",
  "Rapor paftasını aç": "Open report sheet",
  "Poz tablosu": "Price items",
  "Dışa aktar": "Export",
  "Duvar boyu ve kazı": "Wall length and excavation",
  // Başlangıç paftası (CAD)
  "Başla": "Start",
  "Dosyadan aç…": "Open from file…",
  "Bağlantılar": "Links",
  "Başlangıç paftası": "Start sheet",
  "Taş ağırlık, betonarme konsol (T/L) ve payandalı duvar; TS 500 / EN 1992-1-1 / ACI 318-19 kesit tasarımı.": "Masonry gravity, RC cantilever (T/L) and counterfort walls; TS 500 / EN 1992-1-1 / ACI 318-19 section design.",
  "TBDY 2018, Eurocode 7/8-5 ve ABD (ASD) hedefleri aynı girdi üzerinde.": "TBDY 2018, Eurocode 7/8-5 and US (ASD) targets on the same input.",
  "Mononobe-Okabe ile statik ve dinamik itki; her adımın formülü raporda.": "Static and dynamic thrust with Mononobe-Okabe; every step's formula in the report.",
  "Metraj ve keşif: ÇŞB poz numaralı birim fiyat tablosu, XLSX/CSV.": "Quantities and cost estimate: unit-price table with ministry item numbers, XLSX/CSV.",
  "Zemin etüt raporundan (PDF) otomatik girdi okuma — yapay zekâsız, tarayıcıda.": "Automatic input reading from the soil investigation report (PDF) — no AI, in the browser.",
  "Oturumu kapat": "Sign out of your account",
  "Fiyatlar": "Pricing",
  "Yardım": "Help",
  "Göster": "Show",
  "Gizle": "Hide",
  "Caps Lock açık.": "Caps Lock is on.",
  "İstinat duvarı projesini bir öğleden sonrada bitirin.": "Finish a retaining wall design in an afternoon.",
  "Geometri, zemin ve yük girdilerinden devrilme, kayma, taban gerilmesi ve toptan göçme kontrollerini; kesit çizimini; hesap raporunu ve metrajı tek dosyadan üretin.": "From geometry, soil and load inputs, produce overturning, sliding, bearing pressure and global stability checks, the section drawing, the calculation report and the quantity take-off — all from one file.",
  "Anlık kontrol": "Instant checks",
  "Her girdi değişiminde güvenlik sayıları yeniden hesaplanır.": "Safety factors are recalculated on every input change.",
  "Teslim edilebilir çıktı": "Deliverable output",
  "DXF kesit, DOCX hesap raporu, XLSX metraj — ÇŞB birim fiyatlarıyla.": "DXF section, DOCX calculation report, XLSX take-off — with ÇŞB unit prices.",
  "Yönetmeliğe bağlı": "Code-based",
  "TS 7994, Eurocode 7 (EN 1997-1) ve TBDY 2018'e göre.": "Per TS 7994, Eurocode 7 (EN 1997-1) and TBDY 2018.",
  "Gizlilik bildirimi": "Privacy notice",
  "KVKK aydınlatma metni": "KVKK privacy disclosure",
  "E-posta adresinizi girin.": "Enter your e-mail address.",
  "Geçerli bir e-posta adresi girin.": "Enter a valid e-mail address.",
  "Parolanızı girin.": "Enter your password.",
  "E-posta adresiniz henüz doğrulanmamış. Gelen kutunuzdaki bağlantıya tıklayın ya da doğrulama e-postasını yeniden gönderin.": "Your e-mail address is not verified yet. Click the link in your inbox or resend the verification e-mail.",
  "E-posta veya parola hatalı.": "Incorrect e-mail or password.",
  "Parolanız değiştirildi. Yeni parolanızla giriş yapın.": "Your password has been changed. Sign in with your new password.",
  "veya e-posta ile": "or with e-mail",
  "Beni hatırla": "Remember me",
  "Giriş yapılıyor…": "Signing in…",
  "Hesabınız yok mu?": "No account?",
  " — kart istenmez.": " — no card required.",
  "TBDY 2018 · Eurocode 7 · TS 7994": "TBDY 2018 · Eurocode 7 · TS 7994",
  "Taş ağırlık, betonarme konsol ve payandalı duvarlar için devrilme, kayma, taşıma gücü ve kesit tasarımı; metraj, keşif ve kurumlara sunulabilir rapor. Girdiyi değiştirdiğiniz anda kesit ve hükümler yenilenir.": "Overturning, sliding, bearing capacity and section design for stone gravity, RC cantilever and counterfort walls; quantity take-off, cost estimate and a report ready for submission. The section and verdicts update as soon as you change an input.",
  "Projeleriniz hesabınızda saklanır; her cihazdan açılır.": "Your projects are stored in your account and open on any device.",
  "TaşDuvar CAD ekranı: şerit, özellikler paleti, koyu model alanında kesit ve sonuçlar": "TaşDuvar CAD screen: ribbon, properties palette, section and results in the dark model space",
  "Ne yapar?": "What does it do?",
  "Payandalı betonarme duvar: donatı, kesit tasarımı tablosu ve sonuçlar": "Counterfort RC wall: reinforcement, section design table and results",
  "Payandalı betonarme duvarda donatı, kesit tasarımı (TS 500 / EC2 / ACI 318) ve sonuç paleti.": "Reinforcement, section design (TS 500 / EC2 / ACI 318) and results palette for a counterfort RC wall.",
  "Aylık ya da yıllık abonelik; havale/EFT ya da kartla ödeme. Abonelik bitince projeleriniz silinmez, salt okunur kalır.": "Monthly or yearly subscription; pay by bank transfer or card. When the subscription ends your projects are not deleted; they stay read-only.",
  "Planları incele": "See plans",
  "Taş (kargir) ağırlık, betonarme konsol (T/L) ve payandalı duvar; betonarmede TS 500 / EN 1992-1-1 / ACI 318-19 ile kesit tasarımı ve donatı planı.": "Stone (masonry) gravity, RC cantilever (T/L) and counterfort walls; RC section design and reinforcement layout per TS 500 / EN 1992-1-1 / ACI 318-19.",
  "TBDY 2018 γR'li doğrulama, Eurocode 7 kısmi katsayı kombinasyonları (DA1/DA2/DA3) ve ABD ASD aynı duvar üzerinde.": "TBDY 2018 γR verification, Eurocode 7 partial-factor combinations (DA1/DA2/DA3) and US ASD on the same wall.",
  "Mononobe-Okabe ile statik + dinamik itki, duvar ve kama ataleti; her adımın formülü ve yerine konmuş sayıları raporda.": "Static + dynamic thrust with Mononobe-Okabe, wall and wedge inertia; every step's formula and substituted numbers in the report.",
  "CAD gibi çalışır": "Works like CAD",
  "Şerit, komut satırı, katman yöneticisi; ölçüleri çizim üzerinde düzenleyin, çokgen kesit çizin ya da DXF'ten alın.": "Ribbon, command line, layer manager; edit dimensions on the drawing, sketch a polygon section or import it from DXF.",
  "Kazı, dolgu, taş/beton, kalıp, donatı ve drenaj metrajı; ÇŞB 2026 poz numaralı, düzenlenebilir birim fiyatlar.": "Excavation, backfill, stone/concrete, formwork, rebar and drainage quantities; editable unit prices with ÇŞB 2026 item numbers.",
  "Zemin etüt raporunu (PDF) yükleyin; tabaka parametreleri ve deprem katsayıları sayfa referansıyla önerilir, siz onaylarsınız.": "Upload the geotechnical report (PDF); layer parameters and seismic coefficients are suggested with page references, and you approve them.",
  "Duvar tipini seçin, ölçüleri çizim üzerinde düzenleyin; zemin, su, yük ve deprem sekmelerini doldurun.": "Choose the wall type, edit dimensions on the drawing; fill in the soil, water, load and seismic tabs.",
  "Koyu model alanında ölçülü kesit ve sonuç paleti": "Dimensioned section and results palette in the dark model space",
  "Devrilme, kayma, taşıma gücü, dış merkezlilik, toptan göçme; betonarmede donatı. Her değişiklikte kesit ve 3B yenilenir.": "Overturning, sliding, bearing capacity, eccentricity, global stability; reinforcement for RC. The section and 3D view update on every change.",
  "Raporu teslim edin": "Deliver the report",
  "Kapak, girdiler, ölçülü kesit, adım adım hesap, donatı, metraj ve keşif. PDF, Word, DXF ve XLSX.": "Cover, inputs, dimensioned section, step-by-step calculation, reinforcement, quantities and cost estimate. PDF, Word, DXF and XLSX.",
  "Hesap raporu kapağı": "Calculation report cover",
  "Ücretsiz hesap açın": "Create a free account",
  "kabul edersiniz. Ücretsiz hesapta kontrol sonuçlarını görürsünüz; rapor ve çıktılar aboneliğe dahildir.": "With a free account you see the check results; the report and exports are part of a subscription.",
  "Ücretsiz hesap: kontrol sonuçlarını ve güvenlik sayılarını görürsünüz; hesap ayrıntıları, rapor, çizim ve tablo çıktıları, paylaşım ve otomatik boyutlandırma aboneliğe dahildir.": "Free account: you see the check results and safety factors; calculation details, the report, drawing and table exports, sharing and auto-sizing are part of a subscription.",
  "Bulutta en çok": "At most",
  "proje saklanır.": "projects are stored in the cloud.",
  "Aboneliğe dahil": "Included in a subscription",
  "Planları gör": "See plans",
  "aboneliğe dahildir.": "is included in a subscription.",
  "Ücretsiz hesapta duvarınızı çizip kontrollerin sağlanıp sağlanmadığını ve güvenlik sayılarını görürsünüz. Hesap ayrıntıları, rapor, çizim ve tablo çıktıları, paylaşım ve otomatik boyutlandırma için bir plan seçin.": "With a free account you can draw your wall and see whether the checks pass and the safety factors. Choose a plan for calculation details, the report, drawing and table exports, sharing and auto-sizing.",
  "Hesap ayrıntıları, rapor ve çıktılar aboneliğe dahil": "Calculation details, report and exports are included in a subscription",
  "Ücretsiz hesap": "Free account",
  "Metraj ve keşif (miktarlar, donatı, tutarlar)": "Quantities and cost estimate (quantities, reinforcement, amounts)",
  "Ücretsiz hesapta en çok": "A free account stores at most",
  "proje saklanır; daha fazla proje": "projects; more projects",
  "Ücretsiz hesapta kontrol sonuçları ve güvenlik sayıları görüntülenir, bulutta en çok 2 proje saklanır; hesap ayrıntıları, rapor ve dosya çıktıları aboneliğe dahildir. Aylık ve yıllık abonelikler peşin ödenir; süre dolunca hesap ücretsiz hesaba döner, projeleriniz silinmez ve JSON olarak indirilebilir. Havale ile ödeme yönetici onayıyla, kart ödemesi iyzico üzerinden anında etkinleşir. İade: ödemeden sonraki 14 gün içinde, hizmet kullanılmamışsa.": "A free account shows check results and safety factors and stores at most 2 projects in the cloud; calculation details, the report and file exports are part of a subscription. Monthly and yearly subscriptions are paid in advance; when a subscription ends the account returns to a free account, your projects are not deleted and can be downloaded as JSON. Bank transfers are activated after admin approval; card payments via iyzico are activated instantly. Refunds: within 14 days of payment, if the service has not been used.",
  "Rapor aboneliğe dahil": "Report included in a subscription",
  "Hesap raporu aboneliğe dahildir": "The calculation report is included in a subscription",
  "Ücretsiz hesapta duvarınızın kontrolleri sağlayıp sağlamadığını ve güvenlik sayılarını model ekranında görürsünüz. Adım adım hesap, kuvvet tablosu, donatı, metraj ve PDF / Word / DXF / XLSX çıktıları aboneliğe dahildir.": "With a free account you see on the model screen whether your wall passes the checks and its safety factors. The step-by-step calculation, force table, reinforcement, quantities and PDF / Word / DXF / XLSX exports are part of a subscription.",
  "Ücretsiz hesap — yalnız kontrol sonuçları": "Free account — check results only",
  "Kuvvet tablosu, taban gerilmeleri, donatı, metraj ve rapor": "Force table, base pressures, reinforcement, quantities and report",
  "Zemin raporundan veri okuma": "Reading data from the soil report",
  "Otomatik boyutlandırma": "Auto-sizing",
  "Dosya çıktıları (PDF, Word, DXF, XLSX, CSV)": "File exports (PDF, Word, DXF, XLSX, CSV)",
  "Yazdırma": "Printing",
  "Donatı tasarımı": "Reinforcement design",
  "Telefon doğrulaması": "Phone verification",
  "Ücretsiz hesapta proje kaydetmek için telefon numaranızı WhatsApp ile doğrulayın. Her numara yalnız bir hesapta kullanılabilir; abonelerden doğrulama istenmez.": "To save projects with a free account, verify your phone number via WhatsApp. Each number can be used by one account only; subscribers are not asked to verify.",
  "Doğrulama mesajının WhatsApp (Meta) üzerinden, yurt dışındaki sunucularda işlenmesine ve numaramın hesap tekliği için saklanmasına açık rıza veriyorum.": "I explicitly consent to the verification message being processed via WhatsApp (Meta) on servers abroad and to my number being stored to keep accounts unique.",
  "WhatsApp ile doğrula": "Verify with WhatsApp",
  "WhatsApp doğrulama QR kodu": "WhatsApp verification QR code",
  "WhatsApp açıldıysa hazır mesajı gönderin. Bilgisayardaysanız QR kodu telefonunuzla okutun.": "If WhatsApp opened, send the prepared message. On a computer, scan the QR code with your phone.",
  "Kod": "Code",
  "dk geçerli": "min valid",
  "Mesaj ulaşınca bu pencere kendiliğinden kapanır.": "This window closes by itself once the message arrives.",
  "WhatsApp'ı aç": "Open WhatsApp",
  "Yeni kod": "New code",
  "Telefon doğrulaması (WhatsApp)": "Phone verification (WhatsApp)",
  "Ücretsiz hesapta her kişinin tek hesap açabilmesi için telefon numaranız WhatsApp ile doğrulanır: doğrulama kodunu içeren mesajı siz gönderirsiniz, mesaj WhatsApp Business Platform (Meta Platforms Ireland Ltd.) üzerinden bize ulaşır. Numaranız yalnız hesap tekliği için saklanır, pazarlama amacıyla kullanılmaz ve üçüncü kişilerle paylaşılmaz. Bu işlem yurt dışına veri aktarımı içerdiğinden açık rızanıza dayanır; rızanızı vermezseniz abonelik seçerek doğrulamadan devam edebilirsiniz.": "So that each person can open only one free account, your phone number is verified via WhatsApp: you send the message containing the verification code, and it reaches us via the WhatsApp Business Platform (Meta Platforms Ireland Ltd.). Your number is stored only to keep accounts unique; it is not used for marketing and is not shared with third parties. Because this involves transferring data abroad, it is based on your explicit consent; if you do not consent, you can choose a subscription and continue without verification.",
  "Proje sınırı (bulutta kullanıcı başına; dolunca \"önce dışa aktarıp silin\" uyarısı)": "Project limit (per user in the cloud; when full: \"export and delete first\" notice)",
  "Aboneli hesap": "Subscribed account",
  "proje": "projects",
  "Dışa aktar (JSON)": "Export (JSON)",
  "Proje sınırı": "Project limit",
  "Tamam": "OK",
  "Proje sınırına ulaştınız": "You have reached the project limit",
  "Yeni proje açmak için önce en az 1 projenizi dışa aktarın ve silin.": "To start a new project, first export and delete at least 1 project.",
  "Dışa aktarılan JSON dosyasını istediğiniz zaman \"Dosyadan aç…\" ile geri yükleyebilirsiniz.": "You can restore an exported JSON file at any time with \"Open from file…\".",
  "Kaydedilemedi": "Could not save",
  "Kaydedilmemiş değişiklik": "Unsaved changes",
  "Kaydediliyor…": "Saving…",
  "Kaydetme": "Don't save",
  "projesinde kaydedilmemiş değişiklik var.": "has unsaved changes.",
  "Kaydetmek ister misiniz?": "Do you want to save them?",
  "projesindeki değişiklikler kaydedilsin mi?": "has changes. Save them?",
  "Kaydetmezseniz açılıştan ya da son kayıttan bu yana yapılan değişiklikler geri alınır.": "If you don't save, changes made since the project was opened or last saved are discarded.",
  "Proje sunucuda değişmiş": "The project has changed on the server",
  "Kaydet (Ctrl+S)": "Save (Ctrl+S)",
  "Projeyi kaydet (kayıt noktası; JSON için Dışa aktar)": "Save project (save point; use Export for JSON)",
  "Bu proje başka bir sekmede açık; bu sekmede salt okunur.": "This project is open in another tab; it is read-only in this tab.",
  "Bu proje başka bir sekmede düzenlemeye alındı; bu sekme salt okunur.": "This project is now being edited in another tab; this tab is read-only.",
  "Bu sekmede düzenle": "Edit in this tab",
  "Akıllı tasarım": "Smart design",
  "Akıllı": "Smart",
  "tasarım": "design",
  "Akıllı tasarım: taş ve betonarme otomatik boyutlandırma, maliyet karşılaştırması": "Smart design: automatic sizing of stone and RC walls, cost comparison",
  "Analiz yap": "Analyse",
  "Akıllı tasarım girdileri": "Smart design inputs",
  "Aktif taraf — dolgu": "Active side — backfill",
  "Çok tabakalı dolgu: yalnız 1. tabaka burada; diğerleri Model paftasında.": "Layered backfill: only layer 1 here; the others are on the Model sheet.",
  "Pasif taraf — ön ve temel zemini": "Passive side — front and foundation soil",
  "ayrıntı Model › Deprem": "details under Model › Seismic",
  "Malzeme ve kontrol ayarları duvardan alınır. Her tip için tüm kontrolleri sağlayan en ucuz boyut aranır; birim fiyatlar Metraj › Poz tablosundan.": "Material and check settings come from the wall. For each type the cheapest size that passes all checks is searched; unit prices come from Quantities › Price table.",
  "Karşılaştırma alanı": "Comparison area",
  "Akıllı tasarım (otomatik boyutlandırma ve maliyet karşılaştırması)": "Smart design (automatic sizing and cost comparison)",
  "Tip karşılaştırması": "Type comparison",
  "daha ekonomik": "is more economical",
  "fark": "difference",
  "toplam": "total",
  "EN EKONOMİK": "MOST ECONOMICAL",
  "Bu duvarı kullan": "Use this wall",
  "Boyutlar": "Dimensions",
  "Güvenlik (etki / dayanım)": "Safety (effect / resistance)",
  "Tüm kontroller sağlanıyor; 1'e yakın = sınırda.": "All checks pass; close to 1 = at the limit.",
  "Maliyet": "Cost",
  "1 m": "1 m",
  "Ekonomik seçeneğe göre": "Compared with the economical option",
  "En dar taban": "Narrowest base",
  "Soldaki alanları doldurup \"Analiz yap\"a basın.": "Fill in the fields on the left and press \"Analyse\".",
  "Yalnız duvar yüksekliği ve zemin değerleri: taş ve betonarme duvar otomatik boyutlanır, maliyetleri karşılaştırılır": "Only wall height and soil values: stone and RC walls are sized automatically and their costs compared",
  "Akıllı tasarımla başla": "Start with smart design",
  "Çıktılar: şerit › Metraj › XLSX / CSV": "Outputs: ribbon › Quantities › XLSX / CSV",
  "Tasarım": "Design",
  "Zemin etüt": "Soil report",
  "raporundan al": "import",
  "Betonarme": "Reinforced concrete",
  "Donatı katmanı": "Reinforcement layer",
  "Kontroller ve gösterim": "Checks and display",
  "Pafta": "Sheet",
  "Kâğıt": "Paper",
  "Kâğıt boyutu": "Paper size",
  "Pafta ölçeği": "Sheet scale",
  "Düzen": "Layout",
  "Yeniden": "Re-",
  "diz": "arrange",
  "Blokları varsayılan yerine diz": "Put blocks back in their default places",
  "Paftayı yazdır / PDF": "Print sheet / PDF",
  "CSV (metraj)": "CSV (quantities)",
  "Çıktılar: şerit › Rapor": "Outputs: ribbon › Report",
  "Çizim paftası": "Drawing sheet",
  "Blokları sürükleyerek yerleştirin · tekerlek yakınlaştırır · boş alanda sürükleme kaydırır": "Drag blocks to place them · wheel zooms · dragging empty space pans",
  "Pafta alanı": "Sheet area",
  "Çizim paftası çıktısı (DXF, yazdırma)": "Drawing sheet output (DXF, printing)",
  "Çizim paftası önizlemesi": "Drawing sheet preview",
  "Sığdır": "Fit",
  "Yeniden diz": "Re-arrange",
  "Çizim paftası yazdırma": "Printing the drawing sheet",
  "Otomatik (içeriği sarar)": "Automatic (wraps content)",
  "Yön": "Orientation",
  "Yatay": "Landscape",
  "Dikey": "Portrait",
  "Paftadaki görünümler": "Views on the sheet",
  "A-A kesiti": "Section A-A",
  "Önden görünüş ve barbakanlar": "Front view and weep holes",
  "Plan (payandalar)": "Plan (counterforts)",
  "Donatı kesiti ve tablosu": "Reinforcement section and schedule",
  "Genel notlar": "General notes",
  "Antet": "Title block",
  "Silinenler bölümüne taşınır;": "It moves to Deleted;",
  "gün içinde geri alabilirsiniz.": "days to restore it.",
  "Silinenler": "Deleted",
  "Silinen projeler": "Deleted projects",
  "Kalıcı silinmesine": "Permanently deleted in",
  "gün": "days",
  "projesini geri al": "— restore project",
  "kalıcı olarak silinsin mi? Bu işlem geri alınamaz.": "— delete permanently? This cannot be undone.",
  "projesini kalıcı sil": "— delete project permanently",
  "Kalıcı sil": "Delete permanently",
  "silinsin mi?": "— delete?",
  "Tümünü seç": "Select all",
  "projesini seç": "— select project",
  "Toplu işlem": "Bulk actions",
  "seçili": "selected",
  "Seçimi kaldır": "Clear selection",
  "Seçilenleri sil": "Delete selected",
  "Seçilenleri geri yükle": "Restore selected",
  "Seçilenleri kalıcı sil": "Delete selected permanently",
  "Su itkisi ve taban kaldırması hesaba katılıyor; dolgu suya doygunsa taban çok genişler.": "Water thrust and base uplift are included; with a saturated backfill the base becomes very wide.",
  "Barbakan/dren yapılacaksa su itkisi alınmaz (TBDY 16.12.3.1): suyu kapatın.": "If weep holes/drains will be built, water thrust is not taken (TBDY 16.12.3.1): switch the water off.",
  "Duvar arkası": "Behind the wall",
  "su altında sayılır: su itkisi ve taban kaldırması tabanı çok genişletir. Barbakan/dren yapılacaksa su itkisi alınmaz (TBDY 16.12.3.1).": "is taken as submerged: water thrust and base uplift widen the base a lot. If weep holes/drains will be built, water thrust is not taken (TBDY 16.12.3.1).",
  "Drenajlı: suyu hesaba katma": "Drained: ignore water",
  "Adezyonu TBDY kaymasına da ekle (c·A, yönetmelik dışı)": "Also add adhesion to the TBDY sliding check (c·A, outside the code)",
  "istCAD gibi; TBDY 16.8.4 drenajlı durumda yalnız N·tanδ öngörür": "As in istCAD; TBDY 16.8.4 gives only N·tanδ for drained conditions",
  "Kaymada adezyon c·A (yönetmelik dışı)": "Adhesion c·A in sliding (outside the code)",
  "TBDY kaymasında adezyon (yönetmelik dışı)": "Adhesion in TBDY sliding (outside the code)",
  "Dirence eklendi": "Added to resistance",
  "Yeraltı suyu bilgisi": "Groundwater note",
  "Duvar arkasında yeraltı suyu hesaba katıldı": "Groundwater behind the wall is included",
  "su itkisi ve taban kaldırması tabanı büyütür.": "water thrust and base uplift enlarge the base.",
  "Suyu kapat (drenajlı)": "Switch water off (drained)",
  "güncel girdilerle yeniden hesaplanıyor…": "recalculating with current inputs…",
  "duvara uygulandı": "applied to the wall",
  "Uygun kesit bulunamadı.": "No suitable section found.",
  "Boyutlandırma sonucu": "Sizing result",
  "Kesit bulunamadı": "No section found",
  "Hesap-": "Calcu-",
  "lanıyor…": "lating…",
  "Yeniden boyutlandır: güncel girdilerle (su, kontrol ayarları, zemin) en ucuz kurtaran kesiti bul ve duvara uygula": "Re-size: find the cheapest passing section with the current inputs (water, check settings, soil) and apply it to the wall",
  "Boyut": "Size",
  "Kontrol ayarları": "Check settings",
  "Kontrol ayarları (güvenlik katsayıları, dış merkezlilik B/n)": "Check settings (safety factors, eccentricity B/n)",
  "Yeraltı suyu ayarları": "Groundwater settings",
  "Seçenekler: hesap ve abonelik; yöneticide sağlayıcı ayarları": "Options: account and subscription; provider settings for administrators",
  "depremde TBDY'de hüküm yok; EN 1997-1 §6.5.4": "no seismic rule in TBDY; EN 1997-1 §6.5.4",
  "gün sonra sürüm geçmişi ve paylaşım bağlantılarıyla birlikte kalıcı silinir; proje sınırına sayılmaz.": "days later they are deleted permanently together with version history and share links; they do not count towards the project limit.",
  "Blok": "Block",
  "Seçim: blok (tüm görünüm)": "Selection: block (whole view)",
  "Nesne": "Object",
  "Seçim: tek nesne": "Selection: single object",
  "Seç": "Select",
  "Seç aracı": "Select tool",
  "Değiştir": "Modify",
  "Taşı": "Move",
  "Taşı (M)": "Move (M)",
  "Kopyala (C)": "Copy (C)",
  "Ölçekle": "Scale",
  "Ölçekle (S)": "Scale (S)",
  "Döndür": "Rotate",
  "Döndür (R)": "Rotate (R)",
  "Seçileni sil (Del)": "Delete selection (Del)",
  "Yazı düzelt": "Edit text",
  "Yazı düzelt (E, çift tık)": "Edit text (E, double-click)",
  "Çizgi": "Line",
  "Çizgi (L)": "Line (L)",
  "Yazı": "Text",
  "Yazı ekle (T)": "Add text (T)",
  "Pafta düzenlemesini geri al (Ctrl+Z)": "Undo sheet edit (Ctrl+Z)",
  "Pafta düzenlemesini yinele (Ctrl+Y)": "Redo sheet edit (Ctrl+Y)",
  "ÇİZGİ": "LINE",
  "Sonraki nokta (Shift: dik) · Enter / Esc bitir": "Next point (Shift: orthogonal) · Enter / Esc to finish",
  "İlk nokta": "First point",
  "YAZI": "TEXT",
  "Yazı noktası": "Text insertion point",
  "Nesne seçin": "Select objects",
  "Temel nokta": "Base point",
  "nesne": "objects",
  "Açı noktası": "Angle point",
  "İkinci nokta": "Second point",
  "dik": "orthogonal",
  "Ölçek çarpanı": "Scale factor",
  "Açı (°)": "Angle (°)",
  "M taşı · C kopyala · S ölçekle · R döndür · E yazı düzelt · Del sil · L çizgi · T yazı · Ctrl+Z geri al · orta tuş / boşluk + sürükle kaydırır": "M move · C copy · S scale · R rotate · E edit text · Del delete · L line · T text · Ctrl+Z undo · middle button / space + drag pans",
  "Yazı yüksekliği (m)": "Text height (m)",
  "düzenleme duvar değiştiği için uygulanmadı": "edits not applied because the wall changed",
  "Düzenlemeleri sıfırla": "Reset edits",
  "Komut istemi": "Command prompt",
  "TAŞI": "MOVE",
  "KOPYALA": "COPY",
  "ÖLÇEKLE": "SCALE",
  "DÖNDÜR": "ROTATE",
  "Nesne seçin (tıklama · pencere: soldan sağa içindekiler, sağdan sola değenler) · Shift ekler": "Select objects (click · window: left-to-right inside, right-to-left crossing) · Shift adds",
  "Ölçü koy (D)": "Add dimension (D)",
  "Akıllı tasarım nasıl çalışır": "How smart design works",
  "Soldan duvar yüksekliğini girin": "Enter the wall height on the left",
  "Aktif (dolgu) ve pasif (ön zemin) taraf değerlerini kontrol edin": "Check the active (backfill) and passive (front soil) side values",
  "\"Analiz yap\"a basın — taş ve betonarme yan yana gelir, birini seçin": "Press \"Analyse\" — stone and RC appear side by side; pick one",
  "Duvarı program boyutlandırsın mı?": "Let the program size the wall?",
  "Yalnız duvar yüksekliğini ve zemin değerlerini girin; program taş ve betonarme duvarı kurtaran en ekonomik ölçülerle boyutlandırır, metraj ve maliyeti yan yana gösterir. Beğendiğinizi seçip devam edersiniz.": "Enter only the wall height and soil values; the program sizes a stone and an RC wall with the most economical dimensions that pass, and shows quantities and cost side by side. Pick the one you like and continue.",
  "Sonradan her zaman Model paftasında elle değiştirebilirsiniz.": "You can always change it by hand on the Model sheet later.",
  "Boş bir duvarla açılır; ölçüleri siz girersiniz": "Opens with a blank wall; you enter the dimensions",
  "ÖLÇÜ": "DIMENSION",
  "Birinci nokta": "First point",
  "Ölçü çizgisinin yeri (yukarı/aşağı: yatay · sağa/sola: düşey)": "Dimension line location (up/down: horizontal · left/right: vertical)",
  "bitir": "to finish",
  "M taşı · C kopyala · S ölçekle · R döndür · E yazı düzelt · Del sil · L çizgi · T yazı · D ölçü · Ctrl+Z geri al · orta tuş / boşluk + sürükle kaydırır": "M move · C copy · S scale · R rotate · E edit text · Del delete · L line · T text · D dimension · Ctrl+Z undo · middle button / space + drag pans",
  "Hemen analiz et": "Analyse now",
  "Patlat": "Explode",
  "Patlat (X): bloğu tek tek nesnelere aç": "Explode (X): break the block into single objects",
  "Blok yap": "Make block",
  "Blok yap (B): seçili nesneleri tek birim yap": "Make block (B): group the selected objects",
  "Ayna": "Mirror",
  "Ayna (A)": "Mirror (A)",
  "Kot at": "Add level",
  "Kot at (K): tıklanan noktanın kotunu yazar": "Add level (K): writes the elevation of the clicked point",
  "Tablo": "Table",
  "Tablo ekle (Excel'den yapıştır)": "Insert table (paste from Excel)",
  "Özellik": "Properties",
  "Seçilenin katmanı": "Layer of selection",
  "Seçilenin rengi": "Colour of selection",
  "Katmandan": "By layer",
  "TABLO": "TABLE",
  "Tablonun sol üst köşesi": "Top-left corner of the table",
  "KOT": "LEVEL",
  "Kot noktasına tıklayın": "Click the level point",
  "yazı solda": "text on the left",
  "AYNA": "MIRROR",
  "Ayna doğrusunun ikinci noktası": "Second point of mirror line",
  "kaynağı sil": "delete source",
  "Ayna doğrusunun birinci noktası": "First point of mirror line",
  "M taşı · C kopyala · S ölçekle · R döndür · A ayna · Del sil · E yazı düzelt · X patlat · B blok yap · L çizgi · T yazı · D ölçü · K kot · Ctrl+Z geri al · orta tuş / boşluk + sürükle kaydırır": "M move · C copy · S scale · R rotate · A mirror · Del delete · E edit text · X explode · B make block · L line · T text · D dimension · K level · Ctrl+Z undo · middle button / space + drag pans",
  "Tablo ekle": "Insert table",
  "Her satır bir tablo satırı; hücreleri sekme (Excel'den kopyala-yapıştır) ya da ; ile ayırın. İlk satır başlık olur.": "Each line is a table row; separate cells with tabs (copy-paste from Excel) or ;. The first row becomes the header.",
  "Tablo içeriği": "Table content",
  "Kırmızı": "Red",
  "Sarı": "Yellow",
  "Yeşil": "Green",
  "Camgöbeği": "Cyan",
  "Mavi": "Blue",
  "Eflatun": "Magenta",
  "Siyah / beyaz": "Black / white",
  "Gri": "Grey",
  "Boyutlandır": "Size it",
  "\"Boyutlandır\"a basın — taş ve betonarme yan yana gelir, birini seçin": "Press \"Size it\" — stone and RC appear side by side; pick one",
  "Hemen boyutlandır": "Size it now",
  "Önizleme notu": "Preview note",
  "Önizleme —": "Preview —",
  "henüz değişmedi": "has not changed yet",
  "şu an": "currently",
  "Uygulamak için \"Bu duvarı kullan\".": "To apply, press \"Use this wall\".",
  "Girdiler değişti — sonuç güncel değil, yeniden boyutlandırın.": "Inputs changed — result is out of date, size again.",
  "ÖNİZLEME": "PREVIEW",
  "Mevcut duvar → öneri": "Current wall → proposal",
  "Soldaki alanları doldurup \"Boyutlandır\"a basın.": "Fill in the fields on the left and press \"Size it\".",
  "Uygulandı": "Applied",
  "Akıllı tasarım uygulandı": "Smart design applied",
  "Karşılaştırmaya dön": "Back to comparison",
  "Deprem bilgisi": "Seismic info",
  "Hesapta kullanılan deprem": "Seismic input used",
  "Yüksek deprem": "High seismicity",
  "kayma hükmediyor, taban genişler. Pasif direnç, temel/taban sürtünmesi ve deprem girdisini kontrol edin.": "sliding governs and the base gets wide. Check passive resistance, base friction and the seismic input.",
  "Paralel yüzlü, dolguya yatık duvar (sabit kalınlık K)": "Parallel-faced wall battered into the fill (constant thickness K)",
  "Ön yüzü eğik, arka yüzü düşey duvar": "Battered front face, vertical back face",
  "Gövdesi aşağı doğru genişleyen duvar (üst/alt kalınlık)": "Wall widening towards the base (top/bottom thickness)",
  "Konsol gövde + taban plağı": "Cantilever stem + base slab",
  "Duvar kalınlığı K": "Wall thickness K",
  "Gövde taban kalınlığı": "Body thickness at base",
  "Arka yüz eğimi (yatay/düşey)": "Back face batter (horizontal/vertical)",
  "düşey": "vertical",
  "dolguya yatık": "leaning into the fill",
  "dolguya doğru açılan": "opening towards the fill",
  "Devrilme (statik)": "Overturning (static)",
  "Devrilme (deprem)": "Overturning (seismic)",
  "Kayma (statik)": "Sliding (static)",
  "Kayma (deprem)": "Sliding (seismic)",
  "Taşıma gücü (statik)": "Bearing (static)",
  "Taşıma gücü (deprem)": "Bearing (seismic)",
  "Dış merkezlilik (statik)": "Eccentricity (static)",
  "Dış merkezlilik (deprem)": "Eccentricity (seismic)",
  "Derz dış merkezliliği (statik)": "Joint eccentricity (static)",
  "Derz dış merkezliliği (deprem)": "Joint eccentricity (seismic)",
  "Derz kayması (statik)": "Joint sliding (static)",
  "Derz kayması (deprem)": "Joint sliding (seismic)",
  "Derz basıncı (statik)": "Joint compression (static)",
  "Derz basıncı (deprem)": "Joint compression (seismic)",
  "Temel grobeton / beton üstünde": "Foundation on blinding / concrete",
  "Taban sürtünmesi tanδ = 0,6 (TBDY Tablo 16.3); kapalıyken 2φ/3": "Base friction tanδ = 0.6 (TBDY Table 16.3); 2φ/3 when off",
  "tanδ = 0,6 (grobeton / beton temel)": "tanδ = 0.6 (blinding / concrete foundation)",
  "Grobeton / beton temel (tanδ 0,6)": "Blinding / concrete foundation (tanδ 0.6)",
  "Taranmış PDF — metin okunamadı, değerleri elle girin.": "Scanned PDF — no text could be read, enter the values manually.",
  "Rapor bu bilgisayarda okunur (yapay zekâ yok, dosya gönderilmez); değerler onayınızla yazılır.": "The report is read on this computer (no AI, the file is not uploaded); values are written after your approval.",
  "Rapor dosyası (metin katmanlı PDF)": "Report file (PDF with text layer)",
  "Yapay zekâ ile oku (taranmış PDF ve karmaşık tablolar için)": "Read with AI (for scanned PDFs and complex tables)",
  "Yerel okuyucu Türkçe rapor terimlerini (γ, φ, c, taşıma gücü, zemin sınıfı, SS/S1, yeraltı suyu, tabaka tabloları) tanır. Belirsiz değerler önerilmez; uyarılarda gösterilir.": "The local reader recognises Turkish report terms (γ, φ, c, bearing capacity, site class, SS/S1, groundwater, layer tables). Ambiguous values are not proposed; they are listed in the warnings.",
  "Okunuyor…": "Reading…",
  "yerel okuyucu (yapay zekâ yok)": "local reader (no AI)",
  "Zemin etüt raporunuz (PDF) varsa açılan pencerede yükleyin; değerler rapordan okunur.": "If you have a geotechnical report (PDF), upload it in the next window; values are read from the report.",
  "Kesit önizlemesi": "Section preview",
  "AKTİF TARAF — DOLGU": "ACTIVE SIDE — BACKFILL",
  "TEMEL ZEMİNİ": "FOUNDATION SOIL",
  "hesap": "computed",
  "varsayılan SS/S1": "default SS/S1",
  "Deprem hesabı kapalı": "Seismic analysis off",
  "YAS yok": "no groundwater",
  "Temel derinliği": "Foundation depth",
  "YAS derinliği (dolgu üstünden)": "Groundwater depth (from backfill top)",
  "dolgu γ": "backfill γ",
  "dolgu φ": "backfill φ",
  "temel γ": "foundation γ",
  "temel φ": "foundation φ",
  "istinat duvarı": "retaining wall",
  "İstinat duvarı": "Retaining wall",
  "PDF okunamadı": "PDF could not be read",
  "proje adı": "project name",
  "hatalı": "invalid",
  "Eksik girdiler": "Missing inputs",
  "Eksik": "Missing",
  "Girdiler tamam — taş ve betonarme duvar boyutlandırılacak": "Inputs complete — stone and RC walls will be sized",
  "Analize başla": "Start analysis",
  "Akıllı başlangıç": "Smart start",
  "Zemin etüt raporu (isteğe bağlı)": "Geotechnical report (optional)",
  "PDF ya da Word (.docx) raporunu sürükleyip bırakın ya da tıklayıp seçin. Rapor bu bilgisayarda okunur (yapay zekâ kullanılmaz, dosya gönderilmez); bulunan değerler aşağıya yazılır.": "Drag and drop the PDF or Word (.docx) report, or click to choose. The report is read on this computer (no AI, the file is not sent); values found are filled in below.",
  "Dosya seç…": "Choose file…",
  "Zemin etüt raporu (PDF / Word)": "Geotechnical report (PDF / Word)",
  "Temel zemini tabakası": "Foundation soil layer",
  "seçin": "choose",
  "Proje ve duvar": "Project and wall",
  "ör. 4,00": "e.g. 4.00",
  "boş = 10": "empty = 10",
  "Temel zemininden kopyala": "Copy from foundation soil",
  "boş = 0": "empty = 0",
  "Pasif taraf — temel zemini": "Passive side — foundation soil",
  "boş = hesapla": "empty = compute",
  "Rapordaki c_u kullanıldı: drenajsız koşul (φ = 0).": "The report's c_u is used: undrained condition (φ = 0).",
  "Yok / rastlanmadı (YASS duvar tabanının altında)": "None / not encountered (water table below the wall base)",
  "Var — derinliğini girin": "Present — enter its depth",
  "Su seviyesi duvar temel tabanının altında kalıyorsa 'Yok' seçin — hesaba etkisi yoktur.": "If the water level is below the wall's foundation base, choose 'None' — it has no effect on the calculation.",
  "Giriş biçimi": "Input as",
  "Derinlik — dolgu üstünden": "Depth — below top of backfill",
  "Yükseklik — taban üstünden": "Height — above the base",
  "YAS yüksekliği (taban üstünden)": "Water table height (above base)",
  "Su seviyesi duvar tabanının altında → 'Yok' seçebilirsiniz": "The water level is below the wall base → you can choose 'None'",
  "Yok seç": "Choose None",
  "Su, dolgu üstünden": "Water is",
  "derinde": "below the top of the backfill",
  "Su, duvar tabanının": "Water is",
  "üstünde": "above the wall base",
  // Zemin türü (USCS / TS 1500)
  "tip.": "typ.",
  "zemin türünün tipik değeri (deney yerine geçmez)": "typical value for the soil type (not a substitute for testing)",
  "için tipik değer — deney yerine geçmez": "typical value — not a substitute for testing",
  "Zemin türü (USCS / TS 1500)": "Soil type (USCS / TS 1500)",
  "Zemin türü": "Soil type",
  "seçin (isteğe bağlı)": "choose (optional)",
  "(dolgu için uygun değil)": "(not suitable as backfill)",
  "Tipik φ'": "Typical φ'",
  "deney yerine geçmez; değerleri değiştirebilirsiniz.": "not a substitute for testing; you can edit the values.",
  "Bu zemin dolgu için uygun değil: istinat duvarı arkasına granüler, drene olan dolgu (ör. GW, GP, SW, SP) önerilir.": "This soil is not suitable as backfill: a granular, free-draining fill (e.g. GW, GP, SW, SP) is recommended behind a retaining wall.",
  "Dolgu φ çok düşük — itki çok büyür, çözüm çıkmayabilir. Geri dolgu genelde granüler malzemedir (ör. GW/SW, φ ≈ 33–36°); zemin türü seçin.": "Backfill φ is very low — the thrust becomes very large and no solution may be found. Backfill is usually granular (e.g. GW/SW, φ ≈ 33–36°); choose a soil type.",
  "Dolgu kohezyonu itkiyi azaltır, güvensiz olabilir; genelde c = 0 alınır.": "Backfill cohesion reduces the thrust and may be unsafe; c = 0 is usually assumed.",
  "Dolguda kohezyon güvenli tarafta 0 alınır": "Backfill cohesion is taken as 0 (on the safe side)",
  "Raporda": "In the report",
  "Girilen": "Entered",
  "kum/çakıl için çok düşük": "very low for sand/gravel",
  "bu, drenajsız (UU) deney değeri olabilir": "this may be an undrained (UU) test value",
  "seçilen zemin türü için tipik φ'": "typical φ' for the selected soil type is",
  "Raporu kontrol edin.": "Check the report.",
  "Efektif φ' ve c' kullanın ya da raporu kontrol edin.": "Use effective φ' and c' or check the report.",
  "İyi derecelenmiş çakıl": "Well-graded gravel",
  "Kötü derecelenmiş çakıl": "Poorly graded gravel",
  "Siltli çakıl": "Silty gravel",
  "Killi çakıl": "Clayey gravel",
  "İyi derecelenmiş kum": "Well-graded sand",
  "Kötü derecelenmiş kum": "Poorly graded sand",
  "Siltli kum": "Silty sand",
  "Killi kum": "Clayey sand",
  "Düşük plastisiteli silt": "Low-plasticity silt",
  "Düşük plastisiteli kil": "Low-plasticity clay",
  "Yüksek plastisiteli silt": "High-plasticity silt",
  "Yüksek plastisiteli kil": "High-plasticity clay",
  "Siltli-killi kum": "Silty clayey sand",
  "Siltli kil / killi silt": "Silty clay / clayey silt",
  "Organik silt/kil (düşük plastisite)": "Organic silt/clay (low plasticity)",
  "Organik kil (yüksek plastisite)": "Organic clay (high plasticity)",
  "Turba": "Peat",
  "Organik zemin / turba: temel zemini olarak uygun değil — deney şart, tipik değerle tasarım yapılmaz.": "Organic soil / peat: not suitable as foundation soil — testing is required; do not design with typical values.",
  // Temel zemini koşulu
  "Temel zemini koşulu": "Foundation soil condition",
  "Drenajlı (φ′, c′)": "Drained (φ′, c′)",
  "Drenajsız (φ = 0, cu)": "Undrained (φ = 0, cu)",
  "cu (drenajsız kayma dayanımı)": "cu (undrained shear strength)",
  "küçük: bu büyük olasılıkla drenajsız deney sonucudur. Killi temel zemininde kısa dönem için drenajsız (cu) hesap önerilir.": "is small: this is most likely an undrained test result. For a clayey foundation soil, an undrained (cu) short-term analysis is recommended.",
  "Drenajsız hesapla": "Use undrained analysis",
  "Drenajsız koşul: φ = 0, kayma dayanımı cu (kısa dönem). cu değerini rapordan kontrol edin.": "Undrained condition: φ = 0, shear strength cu (short term). Check the cu value against the report.",
  "drenajsız: φ = 0": "undrained: φ = 0",
  // Düşük φ onayı
  "Düşük φ onayı": "Low φ confirmation",
  "çok düşük. Rapordaki değer drenajsız deney (UU) sonucu olabilir ya da raporda hata olabilir. Bu değerle duvar çok geniş çıkar.": "is very low. The report value may be an undrained (UU) test result, or the report may contain an error. With this value the wall comes out very wide.",
  "Drenajsız hesapla (cu)": "Use undrained analysis (cu)",
  "Tipik değeri kullan": "Use typical value",
  "Zemin türü seçin": "Choose a soil type",
  "Değeri düzelt": "Correct the value",
  "Evet, eminim — devam et": "Yes, I'm sure — continue",
  "SS/S1 boşsa SS 1,00 · S1 0,25 kullanılır (yüksek deprem varsayımı).": "If SS/S1 are empty, SS 1.00 · S1 0.25 are used (high-seismicity assumption).",
  "Şema oransaldır (ölçekli değil); değerleri değiştirdikçe güncellenir. Kırmızı ? = girilmesi gereken değer. Boyutlar \"Analize başla\" ile programca bulunur.": "The sketch is proportional (not to scale) and updates as you edit. Red ? = value still required. Dimensions are found by the program with \"Start analysis\".",
  "rapordan okundu (üzerine gelince kaynak cümle)": "read from the report (hover for the source sentence)",
  "vars.": "def.",
  "program varsayılanı": "program default",
  "okunuyor…": "reading…",
  "Rapor okuma sonucu": "Report reading result",
  "değer okundu": "values read",
  "Raporda tanınan değer bulunamadı; alanları elle doldurun.": "No recognised values were found in the report; fill in the fields manually.",
  "Okunan değerleri rapordan kontrol edin. Bulunamayan ya da belirsiz değerler boş bırakıldı.": "Check the values read against the report. Values not found or ambiguous were left empty.",
  "Program varsayılanı": "Program default",
  "rapordan, sayfa": "from report, page",
  "s.": "p.",
  "girin": "enter",
  "Raporda belirsiz, doldurulmadı": "Ambiguous in report, not filled",
  "bunu kullan": "use this",
  "Zemin etüt raporunu (PDF) yükleyin; tabaka parametrelerini, taşıma gücünü, yeraltı suyunu ve deprem katsayılarını program sayfa referansıyla önerir — yapay zekâsız, tarayıcıda; siz onaylarsınız.": "Upload the geotechnical report (PDF); the program proposes layer parameters, bearing capacity, groundwater and seismic coefficients with page references — without AI, in your browser; you approve.",
  "Konumdan al": "Pick from location",
  "SS/S1 AFAD ızgarasından (yaklaşık)": "SS/S1 from AFAD grid (approximate)",
  "Haritadan yer seçin; SS ve S1 kendiliğinden gelir.": "Pick the site on the map; SS and S1 are filled in automatically.",
  "\"Konumdan al\" haritası açıldığında harita görüntüleri OpenStreetMap sunucularından yüklenir; tarayıcınız bu sunuculara IP adresinizi iletir. Seçtiğiniz koordinat yalnız projenize kaydedilir.": "When the \"Pick from location\" map is opened, map tiles are loaded from OpenStreetMap servers; your browser sends your IP address to those servers. The selected coordinate is stored only in your project.",
  "Koordinat (enlem, boylam)": "Coordinates (latitude, longitude)",
  "Bu nokta AFAD ızgarasının dışında (Türkiye dışı ya da deniz). SS ve S1'i elle girin.": "This point is outside the AFAD grid (outside Türkiye or at sea). Enter SS and S1 manually.",
  "Deprem tehlike verisi yüklenemedi; bağlantıyı kontrol edin.": "Seismic hazard data could not be loaded; check your connection.",
  "Tarayıcı konum bilgisi vermiyor.": "The browser does not provide location.",
  "Konum izni verilmedi; haritadan seçin ya da koordinat yazın.": "Location permission denied; pick on the map or type the coordinates.",
  "Konumdan deprem değerleri": "Seismic values from location",
  "AFAD'da teyit et": "Verify at AFAD",
  "Uygula": "Apply",
  "Haritada proje yerine tıklayın ya da koordinatı yazın.": "Click the project site on the map or type the coordinates.",
  "Enlem (°)": "Latitude (°)",
  "Boylam (°)": "Longitude (°)",
  "Enlem": "Latitude",
  "Boylam": "Longitude",
  "Konumumu kullan": "Use my location",
  "Izgara değerleri": "Grid values",
  "Nokta seçilmedi": "No point selected",
  "AFAD TDTH parametre ızgarasından (0,1°) enterpolasyonla, yaklaşık ±%1. Resmî rapor için değerleri AFAD'dan teyit edin; zemin sınıfı zemin etüdünden.": "Interpolated from the AFAD TDTH parameter grid (0.1°), about ±1%. Verify the values at AFAD for official reports; the site class comes from the geotechnical report.",
  "Haritadan yer seçin; SS ve S1 AFAD ızgarasından gelir.": "Pick the site on the map; SS and S1 come from the AFAD grid.",
  "Parsel sınırı": "Property line",
  "Dışına çıkılamayacak taraf": "Side that cannot be crossed",
  "Kesitte ön (burun) solda, arka (dolgu) sağda": "In the section the front (toe) is on the left, the back (backfill) on the right",
  "Yok — temel iki yana da çıkabilir": "None — the footing may project on both sides",
  "Sol — ön taraf: burun yapılmaz": "Left — front side: no toe",
  "Sağ — arka taraf: topuk yapılmaz": "Right — back side: no heel",
  "Gövde yüzünden sınıra uzaklık": "Distance from stem face to the line",
  "0 = gövde yüzü sınırda; o yandaki temel çıkıntısı bu değeri aşmaz": "0 = stem face on the line; the footing projection on that side does not exceed this value",
  "PARSEL SINIRI": "PROPERTY LINE",
  "ön (burun) tarafı": "front (toe) side",
  "arka (topuk) tarafı": "back (heel) side",
  "gövde yüzünden": "from the stem face",
  "Başka programla karşılaştırırken taş γ'sını kontrol edin: incelenen istCAD raporlarında 5 t/m³ (≈ 49 kN/m³) girilmiş; harçlı moloz taş gerçekte 22–25 kN/m³. Fazla γ duvarı ağır, tabanı dar gösterir.": "When comparing with other software, check the stone γ: the istCAD reports reviewed used 5 t/m³ (≈ 49 kN/m³); mortared rubble stone is actually 22–25 kN/m³. An excessive γ makes the wall look heavy and the base narrow.",
  "Pasif direnç kapalı: diş kaymaya katkı vermez — Temel sekmesinde açın": "Passive resistance is off: the key does not help against sliding — turn it on in the Foundation tab",
  "Ön zeminin kaymaya katkısı; betonarmede kayma dişi yalnız açıkken denenir": "Contribution of the front soil to sliding; in RC walls a shear key is only tried when this is on",
  "Ok tipi": "Arrow type",
  "Dolu ok": "Closed filled",
  "Eğik çizgi (mimari)": "Oblique tick (architectural)",
  "Ne yapabilirsiniz?": "What can you do?",
  "bu koşullarda sağlıyor": "satisfies all checks here",
  "Bunu kullan": "Use this",
  "Kesiti parsel sınırı belirliyor. Sınır olmasaydı": "The property line governs. Without it:",
  "Gövde sınırdan en az bu kadar uzakta olursa betonarme çözüm çıkar.": "An RC section works if the stem is at least this far from the line.",
  "Sınırdan": "Move",
  "uzaklaştır": "away from line",
  "Sınır kesinse: ankrajlı ya da kazıklı perde duvar. TaşDuvar bunları hesaplamaz; geoteknik proje gerekir.": "If the line is fixed: an anchored or piled wall. TaşDuvar does not design these; a geotechnical design is required.",
  // ── Akıllı tasarım: zemin türü / drenajsız önerisi (2026-10-05)
  "Dolgu φ çok düşük — itki çok büyür. Duvar arkasına genelde granüler dolgu (GW/SW, φ ≈ 34–37°) konur; zemin türünden doldurun.": "Backfill φ is very low — the thrust becomes very large. Retaining walls are usually backfilled with granular fill (GW/SW, φ ≈ 34–37°); fill from soil type.",
  "Killi zeminde raporda küçük φ (ör. 4°) ve cu varsa drenajsız seçin": "For clay with a small φ (e.g. 4°) and cu in the report, choose undrained",
  "φ çok düşük: drenajlı hesapta kohezyon kaymaya katılmaz (TBDY Denk. 16.10). Değer drenajsız deneyden (UU) geldiyse Drenajsız (Ac·cu) seçin.": "φ is very low: in the drained analysis cohesion does not resist sliding (TBDY Eq. 16.10). If the value comes from an undrained (UU) test, choose Undrained (Ac·cu).",
  "Temel zemini φ çok düşük ve drenajlı alınmış: kohezyon kaymaya katılmıyor. Rapordaki küçük φ büyük olasılıkla drenajsız deney (UU) değeridir.": "Foundation soil φ is very low and taken as drained: cohesion does not resist sliding. A small φ in the report is most likely an undrained (UU) test value.",
  "Dolgu φ çok düşük: itki tabanı büyütüyor. Duvar arkasına granüler, drene olan dolgu konur (GW, φ ≈ 37°).": "Backfill φ is very low: the thrust enlarges the base. Retaining walls are backfilled with granular, free-draining fill (GW, φ ≈ 37°).",
  "Drenajsız (cu) hesapla": "Use undrained (cu)",
  "Granüler dolgu al": "Use granular backfill",
  "Zemin türünden doldur": "Fill from soil type",
  "Tipik değer, deney yerine geçmez": "Typical value, not a substitute for testing",
  // ── Denk. 16.23 (2026-10-06)
  "TBDY Denk. 16.23 harfiyen: (1 ± kv) toplam itkiye": "TBDY Eq. 16.23 literally: (1 ± kv) on the total thrust",
  "Statik kısım da (1 ± kv) ile çarpılır (istCAD, iCad); kapalı: yalnız dinamik artım (İMO/AFAD Örnek 1)": "The static part is also multiplied by (1 ± kv) (istCAD, iCad); off: dynamic increment only (İMO/AFAD Example 1)",
  "Düşey ivme (1 ± kv)": "Vertical acceleration (1 ± kv)",
  "Toplam itkiye (Denk. 16.23 harfiyen)": "On the total thrust (Eq. 16.23 literally)",
  "Yalnız dinamik artıma": "On the dynamic increment only",
  // ── Rapor: kabul ve dikkat maddeleri (2026-10-06)
  "Deprem girdisi program varsayılanı (SS 1,00 · S1 0,25 · ZC, yüksek deprem varsayımı). Proje konumunun AFAD TDTH değerleri girilmeden rapor kesin değildir.": "Seismic input is the program default (SS 1.00 · S1 0.25 · ZC, a high-seismicity assumption). The report is not final until the AFAD TDTH values for the project location are entered.",
  "Deprem hesabı yapılmadı (kullanıcı seçimi).": "No seismic analysis was performed (user choice).",
  "Dolgu kohezyonu itkiyi azaltır; tutucu tarafta c = 0 alınması önerilir.": "Backfill cohesion reduces the thrust; c = 0 is recommended on the retained side.",
  "Temel zemini φ < 15° drenajlı alındı; değer drenajsız deneyden geldiyse drenajsız (cu) hesap gerekir.": "Foundation soil φ < 15° was taken as drained; if the value comes from an undrained test, an undrained (cu) analysis is required.",
  "Zemin emniyet gerilmesi etüt raporundan verilmedi; taşıma gücü zemin parametrelerinden hesaplandı (TBDY Denk. 16.8a).": "The allowable bearing pressure was not given from the site investigation report; bearing capacity was computed from the soil parameters (TBDY Eq. 16.8a).",
  "Dikkat:": "Attention:",
  "kabul/uyarı — bkz. Uyarılar ve kabuller": "assumption(s)/warning(s) — see Warnings and Assumptions",
  "Kabuller ve dikkat edilecekler": "Assumptions and points to note",
  // ── Akıllı yönlendirme: yeni proje kartları, φ / su / dolgu c yönlendirmesi, pencerede Konumdan al (2026-10-06)
  "φ'yi bilmiyorsanız zemin türü seçin": "Don't know φ? Choose a soil type",
  "girin ya da zemin türü seçin": "enter or choose a soil type",
  "konum": "loc.",
  "AFAD ızgarasından (yaklaşık)": "from the AFAD grid (approximate)",
  "AFAD TDTH ızgarasından (yaklaşık) — resmî rapor için AFAD'dan teyit edin": "From the AFAD TDTH grid (approximate) — confirm with AFAD for the official report",
  "Başlamadan önce kontrol": "Check before starting",
  "Su itkisi tabanı büyütür; barbakan/dren yapılacaksa suyu hesaba katmayın.": "Water pressure enlarges the base; if weep holes/drains will be built, leave the water out of the analysis.",
  "Suyu hesaba katma": "Ignore the water",
  "Dolgu kohezyonu itkiyi azaltır (güvensiz).": "Backfill cohesion reduces the thrust (unsafe).",
  "Dolguda c = 0 al": "Use c = 0 for the backfill",
  "Nasıl başlamak istersiniz?": "How would you like to start?",
  "Akıllı tasarım (önerilen)": "Smart design (recommended)",
  "Zemin raporu ya da birkaç değerle taş ve betonarme duvarı program boyutlandırır; metraj ve maliyeti yan yana gösterir.": "From a soil report or a few values the program sizes the stone and reinforced concrete walls and shows quantities and cost side by side.",
  "Boş duvarla başla": "Start with a blank wall",
  "Kesiti kendim çizerim; ölçüleri ve zemin değerlerini Model paftasında girerim.": "I'll draw the section myself and enter dimensions and soil values on the Model sheet.",
  "Künye (isteğe bağlı)": "Project details (optional)",
  "il, ilçe, ada, parsel, işveren, müellif, deprem": "province, district, block, parcel, client, engineer, seismic",
  "Oluştur (boş duvar)": "Create (blank wall)",
  // Akıllı yönlendirme (2026-10-06): otomatik uygulama, sonraki adım, sağlamayan duvar önerisi
  "Seçtiğiniz duvar projeye yazılır.": "The wall you choose is written to the project.",
  "Duvara uygulandı": "Applied to wall",
  "Duvar arkasında yeraltı suyu hesaba katılmış. Barbakan/dren yapılacaksa su itkisi alınmaz (TBDY 16.12.3.1).": "Groundwater behind the wall is included. If weep holes/drains are provided, water pressure is not taken (TBDY 16.12.3.1).",
  "Dolguda kohezyon var: dolgu kohezyonu ıslanınca/zamanla kaybolur, tutucu tarafta c = 0 alınır.": "The backfill has cohesion: backfill cohesion is lost when wetted/over time; on the safe side c = 0 is taken.",
  "Dolguda c = 0 al (tutucu)": "Take c = 0 in backfill (conservative)",
  "Raporu aç": "Open report",
  "Otomatik uygulandı": "Applied automatically",
  "En ekonomik çözüm duvara uygulandı": "Most economical solution applied to the wall",
  "Tercih ederseniz": "If you prefer",
  "kartında \"Bu duvarı kullan\".": "— use \"Use this wall\" on its card.",
  "Sağlamayan duvar için öneri": "Suggestion for a failing wall",
  "Kurtaran boyutu program bulsun:": "Let the program find dimensions that pass:",
  "Akıllı tasarımla boyutlandır": "Size with smart design",
  "Duvarın kendi tipinde en ucuz kurtaran kesiti bul ve uygula": "Find and apply the cheapest passing section of the wall's own type",
  "Yeniden boyutlandır": "Resize",
  // Telefon düzeni (2026-10-06): Model çekmeceleri, sonuç alt sayfası, Akıllı tasarım sekmeleri
  "Ara kesit": "Joint section",
  "Betonarme kesit": "RC section",
  "Paletler": "Palettes",
  "Akıllı tasarım görünümü": "Smart design view",
  // Akıllı proje sihirbazı + adım çubuğu (2026-10-06)
  "Zemin ve yükler": "Soil and loads",
  "Zemin": "Soil",
  "Seç ve uygula": "Pick and apply",
  "Rapor / Çizim": "Report / Drawing",
  "Kontrol sağlanmıyor — Akıllı tasarımla boyutlandırın": "Checks not satisfied — size it with smart design",
  "Salt okunur: sihirbaz açılamaz": "Read-only: the wizard cannot be opened",
  "Sihirbaz: zemin raporu, zemin türü, yükler, su ve deprem": "Wizard: soil report, soil type, loads, water and seismic",
  "Akıllı tasarım: taş ve betonarme kesiti otomatik boyutlandır": "Smart design: size stone and RC sections automatically",
  "Akıllı tasarım aboneliğe dahil": "Smart design is included in the subscription",
  "Akıllı tasarım: en uygun kesiti seçip duvara uygulayın": "Smart design: pick the best section and apply it to the wall",
  "Raporu aç (Çizim paftası da bu adımı tamamlar)": "Open the report (the Drawing sheet also completes this step)",
  "Akıllı proje adımları": "Smart project steps",
  "Akıllı proje": "Smart project",
  "tamam": "done",
  "sıradaki adım": "next step",
  "kontrol sağlanmıyor": "checks not satisfied",
  "Adım çubuğunu gizle": "Hide the step bar",
  "Adım çubuğunu gizle (Başlangıç › Tasarım › Sihirbaz açılınca yeniden görünür)": "Hide the step bar (it reappears when Home › Design › Wizard is opened)",
  "SİHİRBAZ": "WIZARD",
  "zemin ve yükler yazıldı": "soil and loads written",
  "boyutlandırılıyor…": "sizing…",
  "zemin ve yükler yazıldı (payandalı / çokgen kesitte otomatik boyutlandırma yok)": "soil and loads written (no automatic sizing for counterfort / polygon sections)",
  "Akıllı tasarım sihirbazı": "Smart design wizard",
  "Girdiler tamam — zemin ve yükler duvara yazılacak": "Inputs complete — soil and loads will be written to the wall",
  "Girdiler tamam — duvara yazılıp yeniden boyutlandırılacak": "Inputs complete — will be written to the wall and re-sized",
  "Değerler bu duvardan alındı; değiştirdikleriniz duvara yazılır (Geri al ile tek adımda geri dönülür).": "Values were taken from this wall; your changes are written to it (Undo reverts them in one step).",
  "Payandalı / çokgen kesit: yükseklik geometriden gelir; otomatik boyutlandırma yok, zemin ve yükler yazılır.": "Counterfort / polygon section: height comes from the geometry; no automatic sizing, soil and loads are written.",
  "Sihir-": "Wiz-",
  "baz": "ard",
  "Sihirbaz: seçili duvar için zemin raporu, zemin türü, yükler, su ve deprem → akıllı tasarım": "Wizard: soil report, soil type, loads, water and seismic for the selected wall → smart design",
  "Zemin değerlerini sihirbazla gözden geçirin: etüt raporu, zemin türü, drenaj koşulu, yeraltı suyu.": "Review the soil values with the wizard: site investigation report, soil type, drainage condition, groundwater.",
  "Sihirbazı aç": "Open wizard",
  "Zemin raporu, zemin türü, drenaj ve yeraltı suyunu adım adım gözden geçir": "Review the soil report, soil type, drainage and groundwater step by step",
  "Sihirbaz": "Wizard",
  "Künyeye eklenecek": "Will be added to the project info",
  "künye tamamlandı": "project info completed",
  // Telefon üst çubuğu (katlı şerit + ⋯ menü)
  "Şerit (komutlar)": "Ribbon (commands)",
  "Diğer komutlar": "More commands",
};
